<template>
    <!-- 上拉弹窗 -->
    <div class="modal-layer-wrap">
        <transition name="trans_bot_modal" mode="out-in">
            <!-- 人员信息弹窗 -->
            <div class="per-info-wrap modal-list" v-if="optionBtnIndex === 0" key="list1" :class="{'active': optionBtnIndex === 0}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    人员信息
                </span>
                </div>
                <div class="modal-body">
                    <div class="option-wrap">
                        <div class="form-wrap">
                            <Input v-model="inpVal" placeholder="请输入名称关键字" clearable
                                style="width: 200px"/>
                            <Button type="primary" @click="inputSearch">搜索</Button>
                        </div>
                    </div>
                    <div class="table-wrap modal-table-wrap block-detail-table">
                        <div class="table-head">
                            <table>
                                <tr>
                                    <th>
                                        姓名
                                    </th>
                                    <th>
                                        联系方式
                                    </th>
                                    <th>
                                        消防职位
                                    </th>
                                    <th>
                                        证书名称
                                    </th>
                                    <th>
                                        状态
                                    </th>
                                    <th width="20%">
                                        上次登录时间
                                    </th>
                                    <!-- <th>
                                        重置密码
                                    </th>
                                    <th>
                                        状态变更
                                    </th> -->
                                    <th>
                                        操作
                                    </th>
                                </tr>
                            </table>
                        </div>
                        <div class="table-body mCustomScrollbar1">
                            <table>
                                <tr v-for="(item, index) in tableTdArr" :key="index">
                                    <td>
                                        <Poptip
                                            v-if="item.userName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.userName"
                                        >
                                            {{item.userName}}
                                        </Poptip>
                                    </td>
                                    <td>
                                        <Poptip
                                            v-if="item.userPhone"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.userPhone"
                                        >
                                            {{item.userPhone}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.roleTypeName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.roleTypeName"
                                        >
                                            {{item.roleTypeName}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.certificateTypeCodeName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.certificateTypeCodeName"
                                        >
                                            {{item.certificateTypeCodeName}}
                                        </Poptip>
                                    </td>
                                    <td>
                                        <Poptip
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.state == 1 ? '正常' : '冻结'"
                                        >
                                            {{item.state == 1 ? '正常' : '冻结'}}
                                        </Poptip>
                                    </td>
                                    <td width="20%">
                                        <Poptip
                                            v-if="item.lastLoginTime"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="timestampToTime(item.lastLoginTime, 'year')"
                                        >
                                            {{timestampToTime(item.lastLoginTime, 'year')}}
                                        </Poptip>
                                    </td>
                                    <!-- <td>
                                        重置密码
                                    </td>
                                    <td :title="item.state == 0 ? '正常' : '异常'">
                                        {{item.state == 0 ? '正常' : '异常'}}
                                    </td> -->
                                    <td>
                                        <Poptip
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            content="详情"
                                        >
                                            <Icon size="20" @click="showDetailFn(0,item.id)" type="ios-information-circle-outline" style="cursor: pointer"/>
                                        </Poptip>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                        <div class="loading" v-if="loading_status">
                            <!-- 加载动画 -->
                            <div class="loading_box" v-show="!tableTdArr.length">
                                <img :src="tableLoad" />
                            </div>
                            <div class="more_data_box" v-show="tableTdArr.length">
                                <img :src="tableMore" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-info-layer" :class="{'active': detailLayerIndex === 0}">
                    <div class="detail-head-wrap">
                    <span>
                        {{formValidate.userName}} / 详情
                    </span>
                        <Button type="primary" class="modal-input" @click="hideDetail">返回</Button>
                    </div>
                    <div class="detail-body-wrap">
                        <div class="form-wrap modal-form-wrap">
                            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="责任人" prop="userName">
                                        <Input v-model="formValidate.userName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="联系方式" prop="userPhone">
                                        <Input v-model="formValidate.userPhone" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="身份证号" prop="idCode">
                                        <Input v-model="formValidate.idCode" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="用户文化程度" prop="idCode">
                                        <Input v-model="formValidate.eduInfo" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="是否受过消防培训" prop="trainingFlag">
                                        <RadioGroup v-model="formValidate.trainingFlag">
                                            <Radio :label="0" disabled>否</Radio>
                                            <Radio :label="1" disabled>是</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="参加培训时间" prop="trainingTime">
                                        <DatePicker type="date" style="width: 100%;" :value="formValidate.trainingTime" disabled></DatePicker>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="是否为疏散引导员" prop="evacuationGuide">
                                        <RadioGroup v-model="formValidate.evacuationGuide">
                                            <Radio :label="0" disabled>否</Radio>
                                            <Radio :label="1" disabled>是</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="证书名称" prop="certificateTypeCodeName">
                                        <Input v-model="formValidate.certificateTypeCodeName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="证书批准日期" prop="issueDate">
                                        <DatePicker type="date" style="width: 100%;" :value="formValidate.issueDate" disabled></DatePicker>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="证书编号" prop="certificateNum">
                                        <Input v-model="formValidate.certificateNum" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="证书有效期" prop="expiryDate">
                                        <Input v-model="formValidate.expiryDate" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="消防职位" prop="roleTypeName">
                                        <Input v-model="formValidate.roleTypeName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 相关图档 -->
            <div class="per-info-wrap modal-list" v-if="optionBtnIndex === 1" key="list4" :class="{'active': optionBtnIndex === 1}">
                <div class="modal-head">
                    <img :src="close" @click="closeModal" alt="">
                    <span class="tit">
                    相关图档
                </span>
                </div>
                <div class="modal-body">
                    <div class="option-wrap">
                        <div class="form-wrap">
                            <Input v-model="inpVal" placeholder="请输入图档名称" clearable
                                   style="width: 200px"/>
                            <Button type="primary" @click="inputSearch">搜索</Button>
                        </div>
                    </div>
                    <div class="table-wrap modal-table-wrap">
                        <div class="table-head">
                            <table>
                                <tr>
                                    <th width="25%">
                                        图档名称
                                    </th>
                                    <th width="25%">
                                        建筑
                                    </th>
                                    <th width="25%">
                                        楼层
                                    </th>
                                    <th width="25%">
                                        图纸
                                    </th>
                                </tr>
                            </table>
                        </div>
                        <div class="table-body mCustomScrollbar1">
                            <table>
                                <tr v-for="(item, index) in tableTdArr" :key="index">
                                    <td width="25%" >
                                        <Poptip
                                                v-if="item.description"
                                                trigger="hover"
                                                transfer :word-wrap="true"
                                                :content="item.description"
                                        >
                                            {{item.description}}
                                        </Poptip>
                                    </td>
                                    <td width="25%" >
                                        <Poptip
                                                v-if="item.buildingName"
                                                trigger="hover"
                                                transfer :word-wrap="true"
                                                :content="item.buildingName"
                                        >
                                            {{item.buildingName}}
                                        </Poptip>
                                    </td>
                                    <td width="25%" >
                                        <Poptip
                                                v-if="item.floor"
                                                trigger="hover"
                                                transfer :word-wrap="true"
                                                :content="item.floor"
                                        >
                                            {{item.floor}}
                                        </Poptip>
                                    </td>
                                    <td width="25%">
                                        <Poptip
                                                trigger="hover"
                                                transfer :word-wrap="true"
                                                content="查看"
                                        >
                                            <Icon style="cursor: pointer;" v-if="item.filePath" size="20" @click="previewImg(item.filePath)" type="ios-image-outline" />
                                        </Poptip>

                                    </td>
                                </tr>
                            </table>
                        </div>
                        <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                        <div class="loading" v-if="loading_status">
                            <!-- 加载动画 -->
                            <div class="loading_box" v-show="!tableTdArr.length">
                                <img :src="tableLoad" />
                            </div>
                            <div class="more_data_box" v-show="tableTdArr.length">
                                <img :src="tableMore" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 重点部位 -->
            <div class="per-info-wrap modal-list" v-if="optionBtnIndex === 2" key="list2" :class="{'active': optionBtnIndex === 2}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    重点部位
                </span>
                </div>
                <div class="modal-body">
                    <div class="option-wrap">
                        <div class="form-wrap">
                            <Input v-model="inpVal" placeholder="请输入重点部位名称" clearable
                                style="width: 200px"/>
                            <Select v-model="inpBuildingId" clearable transfer :word-wrap="true" placeholder="所属建筑"
                                    style="width:200px">
                                <Option v-for="item in ownerBuildList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                            <Select v-model="inpImportantPartType" clearable transfer :word-wrap="true"
                                    placeholder="请选择重点部位类型" style="width:200px">
                                <Option v-for="item in importTypeList" :value="item.value" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </div>
                        <Button type="primary" @click="inputSearch">搜索</Button>
                    </div>
                    <div class="table-wrap modal-table-wrap">
                        <div class="table-head">
                            <table>
                                <tr>
                                    <th width="15%">
                                        重点部位名称
                                    </th>
                                    <th>
                                        所属建筑
                                    </th>
                                    <th>
                                        耐火等级
                                    </th>
                                    <th>
                                        所在位置
                                    </th>
                                    <th>
                                        重点部位类型
                                    </th>
                                    <th>
                                        防火标志设立情况
                                    </th>
                                    <th>
                                        操作
                                    </th>
                                </tr>
                            </table>
                        </div>
                        <div class="table-body mCustomScrollbar1">
                            <table>
                                <tr v-for="(item, index) in tableTdArr" :key="index">
                                    <td width="15%">
                                        <Poptip
                                            v-if="item.name"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.name"
                                        >
                                            {{item.name}}
                                        </Poptip>
                                    </td>
                                    <td>
                                        <Poptip
                                            v-if="item.buildingName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.buildingName"
                                        >
                                            {{item.buildingName}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.buildingResistFireName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.buildingResistFireName"
                                        >
                                            {{item.buildingResistFireName}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.position"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.position"
                                        >
                                            {{item.position}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.importantPartTypeName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.importantPartTypeName"
                                        >
                                            {{item.importantPartTypeName}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.fireproofSignName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.fireproofSignName"
                                        >
                                            {{item.fireproofSignName}}
                                        </Poptip>
                                    </td>
                                    <td>
                                        <Poptip
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            content="详情"
                                        >
                                            <Icon style="cursor: pointer;" size="20" @click="showDetailFn(1,item.id)" type="ios-information-circle-outline" />
                                        </Poptip>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                        <div class="loading" v-if="loading_status">
                            <!-- 加载动画 -->
                            <div class="loading_box" v-show="!tableTdArr.length">
                                <img :src="tableLoad" />
                            </div>
                            <div class="more_data_box" v-show="tableTdArr.length">
                                <img :src="tableMore" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-info-layer" :class="{'active': detailLayerIndex === 1}">
                    <div class="detail-head-wrap">
                    <span>
                        {{formValidate.name}} / 详情
                    </span>
                        <Button type="primary" class="modal-input" @click="hideDetail">返回</Button>
                    </div>
                    <div class="detail-body-wrap">
                        <div class="modal-form-wrap" style="margin-top: 55px;">
                            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
                                <Row :gutter="32">
                                    <Col span="8">
                                    <FormItem label="责任人" prop="chargePersonName">
                                        <Input v-model="formValidate.chargePersonName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="8">
                                    <FormItem label="身份证号" prop="chargePersonId">
                                        <Input v-model="formValidate.chargePersonId" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="8">
                                    <FormItem label="联系方式" prop="chargePersonTel">
                                        <Input v-model="formValidate.chargePersonTel" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        <p class="sub-tit">
                            重点部位信息
                        </p>
                        <div class="form-wrap modal-form-wrap">
                            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="重点部位名称" prop="name">
                                        <Input v-model="formValidate.name" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="建筑面积" prop="overallFloorage">
                                        <Input v-model="formValidate.overallFloorage" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="所属建筑" prop="buildingName">
                                        <Input v-model="formValidate.buildingName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="重点部位类型" prop="importantPartTypeName">
                                        <Input v-model="formValidate.importantPartTypeName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="所在位置" prop="position">
                                        <Input v-model="formValidate.position" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="所在层数" prop="floor">
                                        <Input v-model="formValidate.floor" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="防火标志设立情况" prop="fireproofSignName">
                                        <Input v-model="formValidate.fireproofSignName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="类别" prop="dutyName">
                                        <Input v-model="formValidate.dutyName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="耐火等级" prop="buildingResistFireName">
                                        <Input v-model="formValidate.buildingResistFireName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="危险源情况" prop="dangerSourceName">
                                        <Input v-model="formValidate.dangerSourceName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="确立消防安全重点部位原因" prop="establishReasonName">
                                        <Input v-model="formValidate.establishReasonName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        <p class="sub-tit">
                            摄像头信息
                        </p>
                        <div class="form-wrap modal-form-wrap">
                            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="绑定摄像头位置" prop="cameraName">
                                        <Input v-model="formValidate.cameraName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 周边资源 -->
            <div class="per-info-wrap modal-list" v-if="optionBtnIndex === 3" key="list5" :class="{'active': optionBtnIndex === 3}">
                <div class="modal-head">
                    <img :src="close" @click="closeModal" alt="">
                    <span class="tit">
                    周边资源
                </span>
                </div>
                <div class="modal-body">
                    <div class="tab-wrap">
                        <Tabs
                                class="modal-input"
                                :animated="false"
                                @on-click="tabChange" v-model="surroundingResources"
                        >
                            <TabPane v-for="item in zbzyList" :label="item.name" :name="item.code" :key="item.code">
                            </TabPane>
                        </Tabs>
                    </div>
                    <div class="option-wrap" style="margin-top: 16px;">
                        <div class="form-wrap">
                            <Input v-model="inpVal" placeholder="请输入名称关键字" clearable
                                   style="width: 200px"/>
                        </div>
                        <Button type="primary" @click="inputSearch">搜索</Button>
                    </div>
                    <div class="table-wrap modal-table-wrap block-detail-table">
                        <div class="table-head">
                            <table v-if="surroundingResources == '1'">
                                <tr>
                                    <th>
                                        名称
                                    </th>
                                    <th>
                                        类别
                                    </th>
                                    <th>
                                        数量
                                    </th>
                                    <th>
                                        主要成分
                                    </th>
                                    <th>
                                        位置
                                    </th>
                                    <th>
                                        负责人
                                    </th>
                                    <th>
                                        联系方式
                                    </th>
                                    <th>
                                        所属单位
                                    </th>
                                    <th>
                                        存储方式
                                    </th>
                                    <th>
                                        危险范围
                                    </th>
                                </tr>
                            </table>
                            <table v-if="surroundingResources == '2'|| surroundingResources == '3'">
                                <tr>
                                  <th>
                                        名称
                                    </th>
                                    <th>
                                        类别
                                    </th>
                                    <th>
                                        位置
                                    </th>
                                    <th>
                                        负责人
                                    </th>
                                    <th>
                                        联系电话
                                    </th>
                                </tr>
                            </table>
                            <table v-if="surroundingResources == '4'">
                                <tr>
                                  <th>
                                        出入口名称
                                    </th>
                                    <th>
                                        位置
                                    </th>
                                    <th>
                                        出入口形式
                                    </th>
                                    <th>
                                        备注
                                    </th>
                                </tr>
                            </table>
                            <table v-if="surroundingResources == '5'">
                                <tr>
                                    <th>
                                        名称
                                    </th>
                                    <th>
                                        级别
                                    </th>
                                    <th>
                                        类别
                                    </th>
                                    <th>
                                        位置
                                    </th>
                                    <th>
                                        最大容纳人数
                                    </th>
                                    <th>
                                        备注
                                    </th>
                                </tr>
                            </table>
                            <table v-if="surroundingResources == '6'">
                                <tr>
                                  <th>
                                        名称
                                    </th>
                                    <th>
                                        位置
                                    </th>
                                    <th>
                                        限高(m)
                                    </th>
                                </tr>
                            </table>
                            <table v-if="surroundingResources == '7'">
                                <tr>
                                  <th>
                                        名称
                                    </th>
                                    <th>
                                        位置
                                    </th>
                                    <th>
                                        值班电话
                                    </th>
                                    <th>
                                        负责人
                                    </th>
                                    <th>
                                        联系方式
                                    </th>
                                </tr>
                            </table>
                        </div>
                        <div class="table-body mCustomScrollbar1" v-if="surroundingResources == '1'">
                            <table>
                                <tr v-for="(item,index) in tableTdArr" :key="index">
                                   <td :title="item.name">{{item.name}}</td>
                                   <td :title="item.categoryTypeName">{{item.categoryTypeName}}</td>
                                   <td :title="item.count">{{item.count}}</td>
                                   <td :title="item.important">{{item.important}}</td>
                                   <td :title="item.address">{{item.address}}</td>
                                   <td :title="item.personLiable">{{item.personLiable}}</td>
                                   <td :title="item.phone">{{item.phone}}</td>
                                   <td :title="item.company">{{item.company}}</td>
                                   <td :title="item.storageMode">{{item.storageMode}}</td>
                                   <td :title="item.dangerScope">{{item.dangerScope}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="table-body mCustomScrollbar1" v-if="surroundingResources == '2'||surroundingResources=='3'">
                            <table>
                                <tr v-for="(item,index) in tableTdArr" :key="index">
                                   <td :title="item.name">{{item.name}}</td>
                                   <td :title="surroundingResources=='2'?item.gasStationName:item.waterSourceTypeName">{{surroundingResources=='2'?item.gasStationName:item.waterSourceTypeName}}</td>
                                   <td :title="item.address">{{item.address}}</td>
                                   <td :title="item.chargePerson">{{item.chargePerson}}</td>
                                   <td :title="item.phone">{{item.phone}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="table-body mCustomScrollbar1" v-if="surroundingResources == '4'">
                            <table>
                                <tr v-for="(item,index) in tableTdArr" :key="index">
                                   <td :title="item.name">{{item.name}}</td>
                                   <td :title="item.address">{{item.address}}</td>
                                   <td :title="item.modality">{{item.modality}}</td>
                                   <td :title="item.remark">{{item.remark}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="table-body mCustomScrollbar1" v-if="surroundingResources == '5'">
                            <table>
                                <tr v-for="(item,index) in tableTdArr" :key="index">
                                   <td :title="item.name">{{item.name}}</td>
                                   <td :title="item.refugeLevelName">{{item.refugeLevelName}}</td>
                                   <td :title="item.refugeName">{{item.refugeName}}</td>
                                   <td :title="item.address">{{item.address}}</td>
                                   <td :title="item.galleryful">{{item.galleryful}}</td>
                                   <td :title="item.remark">{{item.remark}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="table-body mCustomScrollbar1" v-if="surroundingResources == '6'">
                            <table>
                                <tr v-for="(item,index) in tableTdArr" :key="index">
                                   <td :title="item.name">{{item.name}}</td>
                                   <td :title="item.address">{{item.address}}</td>
                                   <td :title="item.heightLimit">{{item.heightLimit}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="table-body mCustomScrollbar1" v-if="surroundingResources == '7'">
                            <table>
                                <tr v-for="(item,index) in tableTdArr" :key="index">
                                   <td :title="item.name">{{item.name}}</td>
                                   <td :title="item.address">{{item.address}}</td>
                                   <td :title="item.dutyPhone">{{item.dutyPhone}}</td>
                                   <td :title="item.chargePerson">{{item.chargePerson}}</td>
                                   <td :title="item.phone">{{item.phone}}</td>
                                </tr>
                            </table>
                        </div>
                        <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                        <div class="loading" v-if="loading_status">
                            <!-- 加载动画 -->
                            <div class="loading_box" v-show="!tableTdArr.length">
                                <img :src="tableLoad" />
                            </div>
                            <div class="more_data_box" v-show="tableTdArr.length">
                                <img :src="tableMore" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 建筑构物 -->
            <div class="per-info-wrap modal-list" v-if="optionBtnIndex === 4" key="list3" :class="{'active': optionBtnIndex === 4}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    建筑构物
                </span>
                </div>
                <div class="modal-body">
                    <div class="option-wrap">
                        <div class="form-wrap">
                            <Input v-model="inpVal" placeholder="请输入建筑名称" clearable
                                style="width: 200px"/>
                            <Button type="primary" @click="inputSearch">搜索</Button>
                        </div>
                    </div>
                    <div class="table-wrap modal-table-wrap block-detail-table">
                        <div class="table-head">
                            <table>
                                <tr>
                                    <th>
                                        建筑名称
                                    </th>
                                    <th>
                                        建筑类别
                                    </th>
                                    <th>
                                        使用性质
                                    </th>
                                    <th>
                                        火灾危险性
                                    </th>
                                    <th>
                                        耐火等级
                                    </th>
                                    <th>
                                        建筑高度（m）
                                    </th>
                                    <th>
                                        日常工作时间人数（个）
                                    </th>
                                    <th>
                                        操作
                                    </th>
                                </tr>
                            </table>
                        </div>
                        <div class="mCustomScrollbar1 table-body">
                            <table>
                                <tr v-for="(item, index) in tableTdArr" :key="index">
                                    <td >
                                        <Poptip
                                            v-if="item.name"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.name"
                                        >
                                            {{item.name}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.buildingTypeName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.buildingTypeName"
                                        >
                                            {{item.buildingTypeName}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.buildingUseKindName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.buildingUseKindName"
                                        >
                                            {{item.buildingUseKindName}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.buildingFireDangerName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.buildingFireDangerName"
                                        >
                                            {{item.buildingFireDangerName}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.buildingResistFireName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.buildingResistFireName"
                                        >
                                            {{item.buildingResistFireName}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.buildHeight"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.buildHeight"
                                        >
                                            {{item.buildHeight}}
                                        </Poptip>
                                    </td>
                                    <td width="15%" >
                                        <Poptip
                                            v-if="item.workerNum"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.workerNum"
                                        >
                                            {{item.workerNum}}
                                        </Poptip>
                                    </td>
                                    <td>
                                        <Poptip
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            content="详情"
                                        >
                                            <Icon style="cursor: pointer;" size="20" @click="showDetailFn(2,item.id)" type="ios-information-circle-outline" />
                                        </Poptip>

                                    </td>
                                </tr>
                            </table>
                        </div>
                        <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                        <div class="loading" v-if="loading_status">
                            <!-- 加载动画 -->
                            <div class="loading_box" v-show="!tableTdArr.length">
                                <img :src="tableLoad" />
                            </div>
                            <div class="more_data_box" v-show="tableTdArr.length">
                                <img :src="tableMore" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-info-layer" :class="{'active': detailLayerIndex === 2}">
                    <div class="detail-head-wrap">
                    <span>
                        {{formValidate.name}}
                    </span>
                        <Button type="primary" class="modal-input" @click="hideDetail">返回</Button>
                    </div>
                    <div class="detail-body-wrap">
                        <p class="sub-tit">
                            必填信息
                        </p>
                        <div class="form-wrap modal-form-wrap">
                            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="建筑构物类别" prop="buildingStructureTypeCode">
                                        <RadioGroup v-model="formValidate.buildingStructureTypeCode">
                                            <Radio label='1' disabled>建筑物</Radio>
                                            <Radio label='2' disabled>构筑物</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="建筑名称" prop="name">
                                        <Input v-model="formValidate.name" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="建筑类别" prop="buildingTypeName">
                                        <Input v-model="formValidate.buildingTypeName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="建筑日期" prop="buildTime">
                                        <DatePicker :value="formValidate.buildTime" type="date" style="width: 100%;" disabled></DatePicker>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="使用性质" prop="buildingUseKindName">
                                        <Input v-model="formValidate.buildingUseKindName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="火灾危险性" prop="buildingFireDangerName">
                                        <Input v-model="formValidate.buildingFireDangerName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="耐火等级" prop="buildingResistFireName">
                                        <Input v-model="formValidate.buildingResistFireName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="结构类型" prop="buildingStructureName">
                                        <Input v-model="formValidate.buildingStructureName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="建筑高度" prop="buildHeight">
                                        <Input v-model="formValidate.buildHeight" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="地上层数" prop="aboveGroundFloors">
                                        <Input v-model="formValidate.aboveGroundFloors" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="地下层数" prop="underGroundFloors">
                                        <Input v-model="formValidate.underGroundFloors" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="建筑面积" prop="overallFloorage">
                                        <Input v-model="formValidate.overallFloorage" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        <p class="sub-tit">
                            可选信息
                        </p>
                        <div class="form-wrap modal-form-wrap">
                            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="占地面积" prop="floorSpace">
                                        <Input v-model="formValidate.floorSpace" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="标准层面积" prop="standardFloorage">
                                        <Input v-model="formValidate.standardFloorage" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="日常工作时间人数" prop="workerNum">
                                        <Input v-model="formValidate.workerNum" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="最大容纳人数" prop="maxnumCapacity">
                                        <Input v-model="formValidate.maxnumCapacity" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="地上层面积" prop="aboveGroundArea">
                                        <Input v-model="formValidate.aboveGroundArea" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="地下层面积" prop="underGroundArea">
                                        <Input v-model="formValidate.underGroundArea" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 预案管理 -->
            <div class="per-info-wrap modal-list" v-if="optionBtnIndex === 5" key="list6" :class="{'active': optionBtnIndex === 5}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                  <span class="tit">
                      预案管理
                  </span>
                </div>
                <div class="modal-body">
                    <div class="option-wrap">
                        <div class="form-wrap">
                            <Input v-model="inpVal" placeholder="请输入预案名称" clearable
                                style="width: 200px"/>
                            <DatePicker
                                clearable
                                transfer :word-wrap="true"
                                type="daterange"
                                placeholder="选择时间"
                                style="width: 200px"
                                @on-change="selectTime"
                            ></DatePicker>
                        </div>
                        <Button type="primary" @click="inputSearch">搜索</Button>
                    </div>
                    <div class="table-wrap modal-table-wrap">
                        <div class="table-head">
                            <table>
                                <tr>
                                    <th>
                                        预案名称
                                    </th>
                                    <th>
                                        所属设备
                                    </th>
                                    <th>
                                        预案类型
                                    </th>
                                    <th>
                                        上传人
                                    </th>
                                    <th>
                                        上传时间
                                    </th>
                                    <th>
                                        操作
                                    </th>
                                </tr>
                            </table>
                        </div>
                        <div class="table-body mCustomScrollbar1">
                            <table>
                                <tr v-for="(item, index) in tableTdArr" :key="index">
                                    <td >
                                        <Poptip
                                            v-if="item.name"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.name"
                                        >
                                            {{item.name}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.deviceName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.deviceName"
                                        >
                                            {{item.deviceName}}
                                        </Poptip>
                                    </td>
                                    <td>
                                        <Poptip
                                            v-if="item.reservePlanTypeName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.reservePlanTypeName"
                                        >
                                            {{item.reservePlanTypeName}}
                                        </Poptip>
                                    </td>
                                    <td>
                                        <Poptip
                                            v-if="item.uploadUserName"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.uploadUserName"
                                        >
                                            {{item.uploadUserName}}
                                        </Poptip>
                                    </td>
                                    <td >
                                        <Poptip
                                            v-if="item.uploadTime"
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            :content="item.uploadTime"
                                        >
                                            {{item.uploadTime}}
                                        </Poptip>
                                    </td>
                                    <td>
                                        <Poptip
                                            trigger="hover"
                                            transfer :word-wrap="true"
                                            content="下载"
                                        >
                                            <Icon style="cursor: pointer;" v-if="item.filePath" size="20" @click="open(item.filePath)" type="ios-cloud-download-outline" />
                                        </Poptip>

                                    </td>
                                </tr>
                            </table>
                        </div>
                        <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                        <div class="loading" v-if="loading_status">
                            <!-- 加载动画 -->
                            <div class="loading_box" v-show="!tableTdArr.length">
                                <img :src="tableLoad" />
                            </div>
                            <div class="more_data_box" v-show="tableTdArr.length">
                                <img :src="tableMore" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 视频监控 -->
            <div class="per-info-wrap modal-list" v-if="optionBtnIndex === 6" key="list7" :class="{'active': optionBtnIndex === 6}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    视频监控
                </span>
                </div>
                <div class="page-content">
                    <div class="video-card-list" style="height: 100%;" v-show="!camera">
                        <div class="video-scroll" style="height: 100%;overflow: hidden;" v-show="cardList.length">
                            <ul class="video-list video-list-wrap" >
                                <li class="list-item-wrap" v-for="(item,index) in cardList" :key="index">
                                    <div class="list-item"
                                        @click="targetCamera(item)"
                                        @mouseenter="mouseenterVideo('video_' + item.id, item.hlsAddr)"
                                        @mouseleave="mouseleaveVideo('video_' + item.id)"
                                    >
                                        <div class="video-box">
                                            <div class="item-video" v-if="currentVideoId == 'video_' + item.id" >
                                                <div class="hello-ezuikit-js" v-if="videoType == '1'">
                                                    <div id="video-container" style="width:100%;height:100%"></div>
                                                </div>
                                                <div v-else-if="videoType=='2'">
                                                    <hk-video v-if="videoType=='2' && item.hlsAddr" :previewUrl="item.hlsAddr" :VWidth="'600'" :VHeight="'300'" :videoId="videoSid" :channelNum="channelNum" :sid="videoSid"></hk-video>
                                                </div>
                                                <div v-else-if="videoType=='4'">
                                                    <h5-video v-if="videoType=='4' && item.hlsAddr" :previewUrl="item.hlsAddr" :VWidth="'600'" :VHeight="'300'" :videoId="videoSid" :channelNum="channelNum" :sid="videoSid"></h5-video>
                                                </div>
                                               <div v-else-if="videoType == '5'">
                                                    <videoPlay
                                                        v-if="videoType == '5' && item.hlsAddr"
                                                        :previewUrl="item.hlsAddr"
                                                        :videoId="998"
                                                        :channelNum="channelNum"
                                                        :videoSid="videoSid"
                                                        :videoDeviceId="item.id"
                                                        :height="300"
                                                        :width="600"
                                                        :showClose="false"
                                                    />
                                                </div>
                                                <video
                                                        :id="'video_'+item.id"
                                                        class="video-js vjs-default-skin"
                                                        muted
                                                        v-else
                                                >
                                                    <source :src="item.hlsAddr" />
                                                </video>
                                            </div>
                                            <div v-show="currentVideoId != 'video_' + item.id" class="cover">
                                                <img v-if="item.thumbAddr" :src="item.thumbAddr">
                                                <img v-else :src="iconcamera">
                                            </div>
                                        </div>
                                        <div class="item-title-box">
                                            <div class="item-title">
                                                <p style="font-weight:bold; font-size:14px;color: #08F4F7" :title="item.name">{{item.name}}</p>
                                                <p :title="item.relateName">{{item.relateName}}</p>
                                            </div>
                                            <div class="item-title" style="color:#999;">
                                                <p :title="item.buildingName">{{item.buildingName}}</p>
                                                <p :title="'楼层：' + item.floor">楼层：{{item.floor}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <!--<div class="card-list-page">-->
                                <!--<Page :current="cardPage" :total="cardTotalCount" :page-size="cardPageSize" @on-change="changeCardPage" show-elevator v-if="cardPageSize<cardTotalCount"/>-->
                            <!--</div>-->
                        </div>
                        <div class="center p-t-40" v-show="!cardList.length">
                            <!--<img class="W200" src="@/assets/images/no-data.png" alt="">-->
                            暂无数据
                        </div>
                    </div>
                    <div class="video-card-info" style="height: 100%;display: flex; flex-direction: column;" v-show="camera">
                        <div class="info-title">
                        <!--<div class="info-title" v-show="cardList.length > 1">-->
                            <div class="title-r">
                                <Button type="primary" @click="cancel">返回列表</Button>
                            </div>
                        </div>
                        <div class="video-box" style="width:700px;height:350px;margin:0 auto" v-if="videoSrc">
                            <videoPlay  
                                :previewUrl="videoSrc"
                                :videoId="996" 
                                :channelNum="channelNum" 
                                :videoDeviceId="videoDeviceId"
                                :videoSid="videoSid" @hideClose="videoSrc = ''" :height="350" :width="700" :showClose="false"/>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 3D地图 -->
            <div class="per-info-wrap modal-list" v-if="optionBtnIndex === 7" key="list8" :class="{'active': optionBtnIndex === 7}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span v-if="optionBtnIndex === 7" class="tit">
                    单位立面图
                </span>
                </div>
                <div class="page-content">
                    <iframe class="map-iframe" :src="iframeSrc" width="100%" height="100%" frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" allowtransparency="yes"></iframe>
                </div>
            </div>
            <!--演练详情-->
            <div class="per-info-wrap modal-list pxDetail" v-if="optionBtnIndex === 8" key="list10" :class="{'active': optionBtnIndex === 8}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    演练任务
                </span>
                </div>
                <div class="modal-body" style="padding: 9px 20px;">
                    <div class="detail-head-wrap" style="background: linear-gradient(90deg, rgb(69, 161, 205) 0px, rgb(4, 25, 54) 30%);">
                    <span class="detailTile">
                        演练任务管理 / 详情
                    </span>
                    </div>
                    <div class="detail-body-wrap">
                        <div class="form-wrap modal-form-wrap">
                            <Form  :model="yanlianList" :rules="ruleValidate" :label-width="150">
                                    <span class="dp_fs_color">
                                        演练信息
                                    </span>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="演练标题" prop="userName">
                                        <Input v-model="yanlianList.title" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="演练要求" prop="userPhone">
                                        <Input v-model="yanlianList.requirements" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="开始时间" prop="idCode">
                                        <DatePicker style="width: 100%" :editable="false" type="datetime" disabled :value="timestampToTime(yanlianList.beginTime, 'YYYY-MM-DD hh:mm:ss')"></DatePicker>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="结束时间" prop="idCode">
                                        <DatePicker style="width: 100%" :editable="false" type="datetime" disabled :value="timestampToTime(yanlianList.endTime, 'YYYY-MM-DD hh:mm:ss')"></DatePicker>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="下发单位">
                                        <Input v-model="yanlianList.orgName" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="演练内容" prop="idCode">
                                        <textarea class="detailTextArea"  v-model="yanlianList.content" disabled></textarea>
                                    </FormItem>
                                    </Col>
                                </Row>

                                <span class="dp_fs_color">
                                        反馈信息
                                    </span>
                                <Row :gutter="16">
                                    <Col span="10">
                                    <FormItem label="演练结果">
                                        <Select :disabled="true"  v-model="yanlianList.doneTaskVOS[0].result">
                                            <Option v-for="item in select.result" :value="item.value" :key="item.value">
                                                {{ item.label }}
                                            </Option>
                                        </Select>
                                    </FormItem>
                                    </Col>
                                    <Col span="10">
                                    <FormItem label="演练是否超时">
                                        <RadioGroup v-model="yanlianList.doneTaskVOS[0].overtimeFlag">
                                            <Radio :label="0" disabled>否</Radio>
                                            <Radio :label="1" disabled>是</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                    </Col>
                                </Row>

                                <Row :gutter="16">
                                    <Col span="10">
                                    <FormItem label="演练资料" style="width: 1000px;">
                                        <div v-if="defaultList">
                                            <img v-for="files in defaultList" class="pxylimgs" :src="files.url" @click="showImg(files.url)" alt="">
                                        </div>
                                        <div v-else class="colorGrey">无演练资料</div>
                                    </FormItem>
                                    </Col>
                                </Row>

                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            <!--培训详情-->
            <div class="per-info-wrap modal-list pxDetail" v-if="optionBtnIndex === 9" key="list11" :class="{'active': optionBtnIndex === 9}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    培训任务
                </span>
                </div>
                <div class="modal-body" style="padding: 9px 20px;">
                    <div class="detail-head-wrap" style="background: linear-gradient(90deg, rgb(69, 161, 205) 0px, rgb(4, 25, 54) 30%);">
                    <span class="detailTile">
                        培训任务管理 / 详情
                    </span>
                    </div>
                    <div class="detail-body-wrap">
                        <div class="form-wrap modal-form-wrap">
                            <Form  :model="peixunList" :rules="ruleValidate" :label-width="150">
                                    <span class="dp_fs_color" style="font-size: 16px;">
                                        培训信息
                                    </span>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="培训标题" prop="userName">
                                        <Input v-model="peixunList.title" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="12">
                                    <FormItem label="开始时间" prop="idCode">
                                        <DatePicker style="width: 100%" :editable="false" type="datetime" disabled :value="timestampToTime(peixunList.beginTime, 'YYYY-MM-DD hh:mm:ss')"></DatePicker>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="结束时间" prop="idCode">
                                        <DatePicker style="width: 100%" :editable="false" type="datetime" disabled :value="timestampToTime(peixunList.endTime, 'YYYY-MM-DD hh:mm:ss')"></DatePicker>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="32">
                                    <Col span="12">
                                    <FormItem label="培训内容" prop="idCode">
                                        <textarea class="detailTextArea"  v-model="peixunList.content" disabled></textarea>
                                    </FormItem>
                                    </Col>
                                </Row>

                                <span class="dp_fs_color" style="font-size: 16px;">
                                        反馈信息
                                    </span>
                                <Row :gutter="16">
                                    <Col span="10">
                                    <FormItem label="合格率">
                                        <Input v-model="peixunList.doneTaskVOS[0].percentRate" disabled></Input>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row :gutter="16">
                                    <Col span="10">
                                    <FormItem label="参加率">
                                        <Input v-model="peixunList.doneTaskVOS[0].joiningRate" disabled></Input>
                                    </FormItem>
                                    </Col>
                                    <Col span="10">
                                    <FormItem label="培训是否超时">
                                        <RadioGroup v-model="peixunList.doneTaskVOS[0].overtimeFlag">
                                            <Radio :label="0" disabled>否</Radio>
                                            <Radio :label="1" disabled>是</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                    </Col>
                                </Row>

                                <Row :gutter="16">
                                    <Col span="10">
                                    <FormItem label="培训照片" style="width: 1000px;">
                                        <div v-if="defaultList">
                                            <img v-for="files in defaultList" class="pxylimgs" :src="files.url" @click="showImg(files.url)" alt="">
                                        </div>
                                        <div v-else class="colorGrey">无演练资料</div>
                                    </FormItem>
                                    </Col>
                                </Row>

                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 查岗 -->
            <div class="per-info-wrap modal-list" v-if="optionBtnIndex === 20" key="list9" :class="{'active': optionBtnIndex === 20}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    值班查岗
                </span>
                </div>
                <div class="page-content">
                    <div class="video-card-list" style="height: 100%;" v-show="!camera">
                        <div class="video-scroll" style="height: 100%;overflow: hidden;" v-show="cardList.length">
                            <ul class="video-list video-list-wrap" >
                                <li class="list-item-wrap" v-for="(item,index) in cardList" :key="index">
                                    <div class="list-item"
                                        @click="targetCamera(item)"
                                        @mouseenter="mouseenterVideo('video_' + item.id, item.hlsAddr)"
                                        @mouseleave="mouseleaveVideo('video_' + item.id)"
                                    >
                                        <div class="video-box">
                                            <div class="item-video" v-if="currentVideoId == 'video_' + item.id" >
                                                <div class="hello-ezuikit-js" v-if="videoType == '1'">
                                                    <div id="video-container" style="width:100%;height:100%"></div>
                                                </div>
                                                <div v-else-if="videoType=='2'">
                                                    <hk-video v-if="videoType=='2' && item.hlsAddr" :previewUrl="item.hlsAddr" :VWidth="'600'" :VHeight="'300'" :videoId="videoSid" :channelNum="channelNum" :sid="videoSid"></hk-video>
                                                </div>
                                                <div v-else-if="videoType=='4'">
                                                    <h5-video v-if="videoType=='4' && item.hlsAddr" :previewUrl="item.hlsAddr" :VWidth="'600'" :VHeight="'300'" :videoId="videoSid" :channelNum="channelNum" :sid="videoSid"></h5-video>
                                                </div>
                                                <div v-else-if="videoType == '5'">
                                                    <videoPlay
                                                        v-if="videoType == '5' && item.hlsAddr"
                                                        :previewUrl="item.hlsAddr"
                                                        :videoId="998"
                                                        :channelNum="channelNum"
                                                        :videoSid="videoSid"
                                                        :videoDeviceId="videoDeviceId"
                                                        :height="300"
                                                        :width="600"
                                                        :showClose="false"
                                                    />
                                                </div>
                                                <video
                                                        :id="'video_'+item.id"
                                                        class="video-js vjs-default-skin"
                                                        muted
                                                        v-else
                                                >
                                                    <source :src="item.hlsAddr" />
                                                </video>
                                            </div>
                                            <div v-show="currentVideoId != 'video_' + item.id" class="cover">
                                                <img v-if="item.thumbAddr" :src="item.thumbAddr">
                                                <img v-else :src="iconcamera">
                                            </div>
                                        </div>
                                        <div class="item-title-box">
                                            <div class="item-title">
                                                <p style="font-weight:bold; font-size:14px;" :title="item.name">{{item.name}}</p>
                                                <p :title="item.relateName">{{item.relateName}}</p>
                                            </div>
                                            <div class="item-title" style="color:#999;">
                                                <p :title="item.buildingName">{{item.buildingName}}</p>
                                                <p :title="'楼层：' + item.floor">楼层：{{item.floor}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <!--<div class="card-list-page">-->
                            <!--<Page :current="cardPage" :total="cardTotalCount" :page-size="cardPageSize" @on-change="changeCardPage" show-elevator v-if="cardPageSize<cardTotalCount"/>-->
                            <!--</div>-->
                        </div>
                        <div class="center p-t-40" v-show="!cardList.length">
                            <!--<img class="W200" src="@/assets/images/no-data.png" alt="">-->
                            暂无数据
                        </div>
                    </div>
                    <div class="video-card-info" style="height: 100%;display: flex; flex-direction: column;" v-show="camera">
                        <!--<div class="info-title" v-show="cardList.length > 1">-->
                        <div class="info-title">
                            <div class="title-r">
                                <Button type="primary" @click="cancel">返回列表</Button>
                            </div>
                        </div>
                        <div class="video-box" style="width:700px;height:350px;margin:0 auto" v-if="videoSrc">
                            <videoPlay 
                                :previewUrl="videoSrc"
                                :videoId="995" 
                                :channelNum="channelNum" 
                                :videoDeviceId="videoDeviceId"
                                :videoSid="videoSid"
                                @hideClose="videoSrc = ''" :height="350" :width="700" :showClose="false"/>
                        </div>
                    </div>
                </div>
            </div>
            <!--巡检检查任务-->
            <div class="per-info-wrap modal-list" v-if="optionBtnIndex === 10" key="list12" :class="{'active': optionBtnIndex === 10}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    防火巡检任务-{{deviceName}}
                </span>
                </div>
                <div class="page-content">
                    <div class="video-card-list" style="height: 100%;">
                        <div class="video-scroll" style="height: 100%;overflow: hidden;">
                            <riskRecord :deviceId="deviceId"></riskRecord>
                        </div>

                    </div>

                </div>
            </div>
            <!-- 事件记录 -->
            <div class="per-info-wrap modal-list" v-if="eventType == 'xfz' || eventType == 'xfz1' || eventType == 'xfz2'" key="list13" :class="{'active': (eventType == 'xfz' || eventType == 'xfz1' || eventType == 'xfz2')}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    事件记录
                </span>
                </div>
                <div class="modal-body">
                    <Tabs
                        v-model="eventTabIndex"
                        :animated='false'
                        @on-click="eventTabChange"
                    >
                        <TabPane label="火灾报警信息" name="0">
                            <div class="tab-head">
                                <p class="dp_fs_color">
                                    火警事件记录
                                </p>
                            </div>
                            <div class="tab-option">
                                <div class="form-wrap modal-form-wrap">
                                    <DatePicker
                                        clearable
                                        transfer :word-wrap="true"
                                        type="daterange"
                                        placeholder="选择时间"
                                        style="width: 150px;"
                                        v-model="selTime"
                                        @on-change="selectTime"
                                    ></DatePicker>
                                <!--  <Select
                                        v-show="eventType == 'xfz'"
                                        v-model="selectVal"
                                        transfer :word-wrap="true"
                                        clearable
                                        style="width: 150px;margin-left: 10px;"
                                        placeholder="请选择火警类型"
                                        @on-change="statusSelectFn"
                                    >
                                        <Option
                                                v-for="item in huoTypeList"
                                                :value="item.code"
                                                :key="item.code"
                                        >
                                            {{ item.name }}
                                        </Option>
                                    </Select> -->
                                    <Select
                                        v-model="handleStatus"
                                        transfer :word-wrap="true"
                                        clearable
                                        style="width: 150px;margin-left: 10px;"
                                        placeholder="处理状态"
                                        
                                    >
                                        <Option value="0">未处理</Option>
                                        <Option value="1">已响应</Option>
                                        <Option value="2">已处理</Option>
                                        <Option value="3">处理中</Option>
                                    </Select>
                                </div>

                                <div class="form-wrap btn-wrap">
                                    <Button type="primary" @click="btnSearch">搜索</Button>
                                </div>
                            </div>
                            <div class="table-wrap modal-table-wrap">
                                <div class="table-head" v-show="tableTdArr.length">
                                    <table>
                                        <tr>
                                            <th>
                                                报警时间
                                            </th>
                                            <th>
                                                报警类型
                                            </th>
                                            <th>
                                                所属建筑
                                            </th>
                                            <th>
                                                所属部件
                                            </th>
                                            <th>
                                                所属设施
                                            </th>
                                            <th>
                                                是否误报
                                            </th>
                                            <th>
                                                当前状态
                                            </th>
                                        </tr>
                                    </table>
                                </div>
                                <div class="table-body eventScroll">
                                    <table>
                                        <tr v-for="(item, index) in tableTdArr" :key="index">
                                            <td >
                                                <Poptip
                                                    v-if="item.ctime"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.ctime"
                                                >
                                                    {{item.ctime}}
                                                </Poptip>
                                            </td>
                                            <td >
                                                <Poptip
                                                    v-if="item.type"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.type"
                                                >
                                                    {{item.type}}
                                                </Poptip>
                                            </td>
                                            <td >
                                                <Poptip
                                                    v-if="item.buildName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.buildName"
                                                >
                                                    {{item.buildName}}
                                                </Poptip>
                                            </td>
                                            <td >
                                                <Poptip
                                                    v-if="item.partName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.partName"
                                                >
                                                    {{item.partName}}
                                                </Poptip>
                                            </td>
                                            <td >
                                                <Poptip
                                                    v-if="item.deviceName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.deviceName"
                                                >
                                                    {{item.deviceName}}
                                                </Poptip>
                                            </td>
                                            <td >
                                                <Poptip
                                                    v-if="item.errorName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.errorName"
                                                >
                                                    {{item.errorName}}
                                                </Poptip>
                                            </td>
                                            <td >
                                                <Poptip
                                                    v-if="item.stateName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.stateName"
                                                >
                                                    {{item.stateName}}
                                                </Poptip>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                                <div class="loading" v-if="loading_status">
                                    <!-- 加载动画 -->
                                    <div class="loading_box" v-show="!tableTdArr.length">
                                        <img :src="tableLoad" />
                                    </div>
                                    <div class="more_data_box" v-show="tableTdArr.length">
                                        <img :src="tableMore" />
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane label="故障信息" name="1">
                            <div class="tab-head">
                                <p class="tit">
                                    故障事件记录
                                </p>
                            </div>
                            <div class="tab-option">
                                <div class="form-wrap modal-form-wrap">
                                    <DatePicker
                                        clearable
                                        transfer :word-wrap="true"
                                        type="daterange"
                                        placeholder="选择时间"
                                        style="width: 150px;"
                                        v-model="selTime"
                                        @on-change="selectTime"
                                    ></DatePicker>
                                    <!-- <Select
                                        v-model="selectVal"
                                        transfer :word-wrap="true"
                                        clearable
                                        style="width: 150px;margin-left: 10px;"
                                        placeholder="请选择故障类型"
                                        @on-change="statusSelectFn"
                                    >
                                        <Option
                                                v-for="item in selectArr"
                                                :value="item.code"
                                                :key="item.code"
                                        >
                                            {{ item.name }}
                                        </Option>
                                    </Select> -->
                                <!-- <Select
                                        v-model="handleStatus"
                                        transfer :word-wrap="true"
                                        clearable
                                        style="width: 150px;margin-left: 10px;"
                                        placeholder="处理状态"
                                        @on-change="handleSelectFn"
                                    >
                                        <Option value="0">未处理</Option>
                                        <Option value="2">已处理</Option>
                                        <Option value="3">处理中</Option>
                                    </Select>-->
                                </div>

                                <div class="form-wrap btn-wrap">
                                    <Button type="primary" @click="btnSearch">搜索</Button>
                                </div>
                            </div>
                            <div class="table-wrap modal-table-wrap">
                                <div class="table-head">
                                    <table>
                                        <tr>
                                            <th>
                                                故障时间
                                            </th>
                                            <th>
                                                所属建筑
                                            </th>
                                            <th>
                                                所属部件
                                            </th>
                                            <th>
                                                所属设施
                                            </th>
                                            <th>
                                                故障类型
                                            </th>
                                        </tr>
                                    </table>
                                </div>
                                <div  class="table-body eventScroll">
                                    <table >
                                        <tr v-for="(item, index) in tableTdArr" :key="index">
                                            <td >
                                                <Poptip
                                                    v-if="item.faultTime"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.faultTime"
                                                >
                                                    {{item.faultTime}}
                                                </Poptip>
                                            </td>
                                            <td>
                                                <Poptip
                                                    v-if="item.building"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.building"
                                                >
                                                    {{item.building}}
                                                </Poptip>
                                            </td>
                                            <td >
                                                <Poptip
                                                    v-if="item.partName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.partName"
                                                >
                                                    {{item.partName}}
                                                </Poptip>
                                            </td>
                                            <td >
                                                <Poptip
                                                    v-if="item.deviceName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.deviceName"
                                                >
                                                    {{item.deviceName}}
                                                </Poptip>
                                            </td>
                                            <td >
                                                <Poptip
                                                    v-if="item.typeName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.typeName"
                                                >
                                                    {{item.typeName}}
                                                </Poptip>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                                <div class="loading" v-if="loading_status">
                                    <!-- 加载动画 -->
                                    <div class="loading_box" v-show="!tableTdArr.length">
                                        <img :src="tableLoad" />
                                    </div>
                                    <div class="more_data_box" v-show="tableTdArr.length">
                                        <img :src="tableMore" />
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
            <!-- 电气、消防水、独立探测器 事件记录 -->
            <div class="per-info-wrap modal-list" v-if="eventType == 'dq'" key="list14" :class="{'active': eventType == 'dq'}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    事件记录
                </span>
                </div>
                <div class="modal-body">
                    <Tabs
                        v-model="eventTabIndex"
                        :animated='false'
                        @on-click="eventTabChange"
                    >
                        <TabPane label="报警" name="0">
                            <div class="tab-head">
                                <p class="tab-tit">
                                    报警事件记录
                                </p>
                            </div>
                            <div class="tab-option">
                                <div class="form-wrap modal-form-wrap">
                                    <DatePicker
                                        clearable
                                        transfer :word-wrap="true"
                                        type="daterange"
                                        placeholder="选择时间"
                                        style="width: 150px;"
                                        v-model="selTime"
                                        @on-change="selectTime"
                                    ></DatePicker>
                                    <Select
                                        v-model="selectVal"
                                        transfer :word-wrap="true"
                                        clearable
                                        style="width: 150px;margin-left: 10px;"
                                        placeholder="请选择报警类型"
                                        @on-change="statusSelectFn"
                                    >
                                        <Option
                                                v-for="item in selectArr"
                                                :value="item.code"
                                                :key="item.code"
                                        >
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                    <Select
                                        v-model="handleStatus"
                                        transfer :word-wrap="true"
                                        clearable
                                        style="width: 150px;margin-left: 10px;"
                                        placeholder="处理状态"
                                        @on-change="handleSelectFn"
                                    >
                                        <Option value="0">未处理</Option>
                                        <Option value="2">已处理</Option>
                                        <Option value="3">处理中</Option>
                                    </Select>
                                </div>

                                <div class="form-wrap btn-wrap">
                                    <Button type="primary" class="search-btn" @click="btnSearch">搜索</Button>
                                </div>
                            </div>
                            <div class="table-wrap modal-table-wrap">
                                <div class="table-head">
                                    <table>
                                        <tr>
                                            <th width="15%">
                                                报警时间
                                            </th>
                                            <th width="10%">
                                                设备名称
                                            </th>
                                            <th width="10%">
                                                测点名称
                                            </th>
                                            <th width="15%">
                                                报警类型
                                            </th>
                                            <th width="20%">
                                                报警内容
                                            </th>
                                            <th width="10%">
                                                处理状态
                                            </th>
                                            <th width="10%">
                                                处理时间
                                            </th>
                                            <th width="10%">
                                                图片
                                            </th>
                                        </tr>
                                    </table>
                                </div>
                                <div class="table-body eventScroll">
                                    <table>
                                        <tr v-for="(item, index) in tableTdArr" :key="index">
                                            <td width="15%">
                                                <Poptip
                                                    v-if="item.ctime"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="getDateFn(item.ctime)"
                                                >
                                                    {{getDateFn(item.ctime)}}
                                                </Poptip>
                                            </td>
                                            <td width="10%" >
                                                <Poptip
                                                    v-if="item.deviceName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.deviceName"
                                                >
                                                    {{item.deviceName}}
                                                </Poptip>
                                            </td>
                                            <td width="10%" >
                                                <Poptip
                                                    v-if="item.pointName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.pointName"
                                                >
                                                    {{item.pointName}}
                                                </Poptip>
                                            </td>
                                            <td width="15%" >
                                                <Poptip
                                                    v-if="item.typeName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.typeName"
                                                >
                                                    {{item.typeName}}
                                                </Poptip>
                                            </td>
                                            <td width="20%" >
                                                <Poptip
                                                    v-if="item.content"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.content"
                                                >
                                                    {{item.content}}
                                                </Poptip>
                                            </td>
                                            <td width="10%" >
                                                <Poptip
                                                    v-if="item.state"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.state"
                                                >
                                                    {{item.state}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                    v-if="item.htime"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="getDateFn(item.htime)"
                                                >
                                                    {{getDateFn(item.htime)}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    content="图片"
                                                >
                                                    <i
                                                        class="iconfont imgView"
                                                        :class="{'active': !item.imgPath}"
                                                        @click="showImg(item.imgPath)"
                                                    >
                                                        &#xe635;
                                                    </i>
                                                </Poptip>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                                <div class="loading" v-if="loading_status">
                                    <div class="loading_box" v-show="!tableTdArr.length">
                                        <img :src="tableLoad" />
                                    </div>
                                    <div class="more_data_box" v-show="tableTdArr.length">
                                        <img :src="tableMore" />
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane label="预警" name="1">
                            <div class="tab-head">
                                <p class="tab-tit">
                                    预警事件记录
                                </p>
                            </div>
                            <div class="tab-option">
                                <div class="form-wrap modal-form-wrap">
                                    <DatePicker
                                        clearable
                                        transfer :word-wrap="true"
                                        type="daterange"
                                        placeholder="选择时间"
                                        style="width: 150px;"
                                        v-model="selTime"
                                        @on-change="selectTime"
                                    ></DatePicker>
                                    <Select
                                        v-model="selectVal"
                                        transfer :word-wrap="true"
                                        clearable
                                        style="width: 150px;margin-left: 10px;"
                                        placeholder="请选择预警类型"
                                        @on-change="statusSelectFn"
                                    >
                                        <Option
                                                v-for="item in selectArr"
                                                :value="item.code"
                                                :key="item.code"
                                        >
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                    <Select
                                        v-model="handleStatus"
                                        transfer :word-wrap="true"
                                        clearable
                                        style="width: 150px;margin-left: 10px;"
                                        placeholder="处理状态"
                                        @on-change="handleSelectFn"
                                    >
                                        <Option value="0">未处理</Option>
                                        <Option value="2">已处理</Option>
                                        <Option value="3">处理中</Option>
                                    </Select>
                                </div>

                                <div class="form-wrap btn-wrap">
                                    <Button type="primary" class="search-btn" @click="btnSearch">搜索</Button>
                                </div>
                            </div>
                            <div class="table-wrap modal-table-wrap">
                                <div class="table-head">
                                    <table>
                                        <tr>
                                            <th width="15%">
                                                预警时间
                                            </th>
                                            <th width="10%">
                                                设备名称
                                            </th>
                                            <th width="10%">
                                                测点名称
                                            </th>
                                            <th width="15%">
                                                预警类型
                                            </th>
                                            <th width="20%">
                                                预警内容
                                            </th>
                                            <th width="10%">
                                                处理状态
                                            </th>
                                            <th width="10%">
                                                处理时间
                                            </th>
                                            <th width="10%">
                                                图片
                                            </th>
                                        </tr>
                                    </table>
                                </div>
                                <div class="table-body eventScroll">
                                    <table>
                                        <tr v-for="(item, index) in tableTdArr" :key="index">
                                            <td width="15%">
                                                <Poptip
                                                    v-if="item.ctime"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="getDateFn(item.ctime)"
                                                >
                                                    {{getDateFn(item.ctime)}}
                                                </Poptip>
                                            </td>
                                            <td width="10%" >
                                                <Poptip
                                                    v-if="item.deviceName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.deviceName"
                                                >
                                                    {{item.deviceName}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                    v-if="item.pointName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.pointName"
                                                >
                                                    {{item.pointName}}
                                                </Poptip>
                                            </td>
                                            <td width="15%">
                                                <Poptip
                                                    v-if="item.typeName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.typeName"
                                                >
                                                    {{item.typeName}}
                                                </Poptip>
                                            </td>
                                            <td width="20%" >
                                                <Poptip
                                                    v-if="item.content"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.content"
                                                >
                                                    {{item.content}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                    v-if="item.state"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.state"
                                                >
                                                    {{item.state}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                    v-if="item.htime"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="getDateFn(item.htime)"
                                                >
                                                    {{getDateFn(item.htime)}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    content="图片"
                                                >
                                                    <i
                                                        class="iconfont imgView"
                                                        :class="{'active': !item.imgPath}"
                                                        @click="showImg(item.imgPath)"
                                                    >
                                                        &#xe635;
                                                    </i>
                                                </Poptip>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                                <div class="loading" v-if="loading_status">
                                    <!-- 加载动画 -->
                                    <div class="loading_box" v-show="!tableTdArr.length">
                                        <img :src="tableLoad" />
                                    </div>
                                    <div class="more_data_box" v-show="tableTdArr.length">
                                        <img :src="tableMore" />
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane label="隐患" name="2">
                            <div class="tab-head">
                                <p class="tab-tit">
                                    隐患事件记录
                                </p>
                            </div>
                            <div class="tab-option">
                                <div class="form-wrap modal-form-wrap">
                                    <DatePicker
                                        clearable
                                        transfer :word-wrap="true"
                                        type="daterange"
                                        placeholder="选择时间"
                                        style="width: 150px;"
                                        v-model="selTime"
                                        @on-change="selectTime"
                                    ></DatePicker>

                                    <Select
                                        v-model="handleStatus"
                                        transfer :word-wrap="true"
                                        clearable
                                        style="width: 150px;margin-left: 10px;"
                                        placeholder="处理状态"
                                        @on-change="handleSelectFn"
                                    >
                                        <Option value="0">未处理</Option>
                                        <Option value="2">已处理</Option>
                                        <Option value="3">处理中</Option>
                                    </Select>
                                </div>

                                <div class="form-wrap btn-wrap">
                                    <Button type="primary" class="search-btn" @click="btnSearch">搜索</Button>
                                </div>
                            </div>
                            <div class="table-wrap modal-table-wrap">
                                <div class="table-head">
                                    <table>
                                        <tr>
                                            <th width="20%">
                                                隐患时间
                                            </th>
                                            <th width="20%">
                                                设备名称
                                            </th>
                                            <th width="20%">
                                                隐患内容
                                            </th>
                                            <th width="20%">
                                                处理状态
                                            </th>
                                            <th width="20%">
                                                处理时间
                                            </th>
                                        </tr>
                                    </table>
                                </div>
                                <div class="table-body eventScroll">
                                    <table>
                                        <tr v-for="(item, index) in tableTdArr" :key="index">
                                            <td width="20%">
                                                <Poptip
                                                    v-if="item.createTime"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="getDateFn(item.createTime)"
                                                >
                                                    {{getDateFn(item.createTime)}}
                                                </Poptip>
                                            </td>
                                            <td width="20%" >
                                                <Poptip
                                                    v-if="item.deviceName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.deviceName"
                                                >
                                                    {{item.deviceName}}
                                                </Poptip>
                                            </td>
                                            <td width="20%" >
                                                <Poptip
                                                    v-if="item.content"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.content"
                                                >
                                                    {{item.content}}
                                                </Poptip>
                                            </td>
                                            <td width="20%" >
                                                <Poptip
                                                    v-if="item.state"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.state"
                                                >
                                                    {{item.state}}
                                                </Poptip>
                                            </td>
                                            <td width="20%">
                                                <Poptip
                                                    v-if="item.htime"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="getDateFn(item.htime)"
                                                >
                                                    {{getDateFn(item.htime)}}
                                                </Poptip>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                                <div class="loading" v-if="loading_status">
                                    <!-- 加载动画 -->
                                    <div class="loading_box" v-show="!tableTdArr.length">
                                        <img :src="tableLoad" />
                                    </div>
                                    <div class="more_data_box" v-show="tableTdArr.length">
                                        <img :src="tableMore" />
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane label="故障" name="3">
                            <div class="tab-head">
                                <p class="tab-tit">
                                    故障事件记录
                                </p>
                            </div>
                            <div class="tab-option">
                                <div class="form-wrap modal-form-wrap">
                                    <DatePicker
                                        clearable
                                        transfer :word-wrap="true"
                                        type="daterange"
                                        placeholder="选择时间"
                                        style="width: 150px;"
                                        v-model="selTime"
                                        @on-change="selectTime"
                                    ></DatePicker>
                                    <Select
                                        v-model="selectVal"
                                        transfer :word-wrap="true"
                                        clearable
                                        style="width: 150px;margin-left: 10px;"
                                        placeholder="请选择故障类型"
                                        @on-change="statusSelectFn"
                                    >
                                        <Option
                                            v-for="item in selectArr"
                                            :value="item.code"
                                            :key="item.code"
                                        >
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                    <Select
                                        v-model="handleStatus"
                                        transfer :word-wrap="true"
                                        clearable
                                        style="width: 150px;margin-left: 10px;"
                                        placeholder="处理状态"
                                        @on-change="handleSelectFn"
                                    >
                                        <Option value="0">未处理</Option>
                                        <Option value="2">已处理</Option>
                                        <Option value="3">处理中</Option>
                                    </Select>
                                </div>

                                <div class="form-wrap btn-wrap">
                                    <Button type="primary" class="search-btn" @click="btnSearch">搜索</Button>
                                </div>
                            </div>
                            <div class="table-wrap modal-table-wrap">
                                <div class="table-head">
                                    <table>
                                        <tr>
                                            <th width="15%">
                                                故障时间
                                            </th>
                                            <th width="15%">
                                                智能部件名称
                                            </th>
                                            <th width="15%">
                                                测点名称
                                            </th>
                                            <th width="10%">
                                                故障类型
                                            </th>
                                            <th width="20%">
                                                故障内容
                                            </th>
                                            <th width="10%">
                                                处理状态
                                            </th>
                                            <th width="15%">
                                                处理时间
                                            </th>
                                        </tr>
                                    </table>
                                </div>
                                <div class="table-body eventScroll">
                                    <table>
                                        <tr v-for="(item, index) in tableTdArr" :key="index">
                                            <td width="15%">
                                                <Poptip
                                                    v-if="item.ctime"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="getDateFn(item.ctime)"
                                                >
                                                    {{getDateFn(item.ctime)}}
                                                </Poptip>
                                            </td>
                                            <td width="15%" >
                                                <Poptip
                                                    v-if="item.deviceName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.deviceName"
                                                >
                                                    {{item.deviceName}}
                                                </Poptip>
                                            </td>
                                            <td width="15%" >
                                                <Poptip
                                                    v-if="item.pointName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.pointName"
                                                >
                                                    {{item.pointName}}
                                                </Poptip>
                                            </td>
                                            <td width="10%" >
                                                <Poptip
                                                    v-if="item.typeName"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.typeName"
                                                >
                                                    {{item.typeName}}
                                                </Poptip>
                                            </td>
                                            <td width="20%" >
                                                <Poptip
                                                    v-if="item.content"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.content"
                                                >
                                                    {{item.content}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                    v-if="item.state"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="item.state"
                                                >
                                                    {{item.state}}
                                                </Poptip>
                                            </td>
                                            <td width="15%">
                                                <Poptip
                                                    v-if="item.htime"
                                                    trigger="hover"
                                                    transfer :word-wrap="true"
                                                    :content="getDateFn(item.htime)"
                                                >
                                                    {{getDateFn(item.htime)}}
                                                </Poptip>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                                <div class="loading" v-if="loading_status">
                                    <!-- 加载动画 -->
                                    <div class="loading_box" v-show="!tableTdArr.length">
                                        <img :src="tableLoad" />
                                    </div>
                                    <div class="more_data_box" v-show="tableTdArr.length">
                                        <img :src="tableMore" />
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
            <!-- 电气火灾监控 -->
            <div class="per-info-wrap device-modal modal-list" v-if="(monitorType == 'dq' || monitorType == 'dq1' || monitorType == 'dq2') && partId" key="list15" :class="{'active': (monitorType == 'dq' || monitorType == 'dq1' || monitorType == 'dq2') && partId}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                    <span class="tit">
                        电气火灾监控-{{monitorName}}
                    </span>
                </div>
                <div class="modal-body yd_wrap">
                    <div class="modal-body-box">
                        <Tabs
                            v-model="tabsSelect"
                            type="card"
                            :animated="false"
                        >
                            <TabPane v-for="tab in tabList" :key="tab" :label="module[tab]" :name="tab">
                                <wit-electric-load v-if="tabsSelect == tab && tab =='fh'" :id="choice.id"></wit-electric-load>
                                <wit-electric-current v-if="tabsSelect == tab && tab =='dl'" :id="choice.id"></wit-electric-current>
                                <wit-electric-voltage v-if="tabsSelect == tab && tab =='dy'" :id="choice.id"></wit-electric-voltage>
                                <wit-electric-rate v-if="tabsSelect == tab && tab =='gl'" :id="choice.id"></wit-electric-rate>
                                <wit-electric-temperature v-if="tabsSelect == tab && tab =='wd'" :id="choice.id"></wit-electric-temperature>
                                <wit-electric-creepage v-if="tabsSelect == tab && tab =='ld'" :id="choice.id"></wit-electric-creepage>
                                <wit-electric-status v-if="tabsSelect == tab && tab =='zt'" :id="choice.id"></wit-electric-status>
                                <wit-control v-if="tabsSelect == tab && tab =='kz'" :id="choice.id"></wit-control>
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </div>
            <!-- 其他设备 -->
            <div class="per-info-wrap modal-list" v-if="eventType == 'qt'||eventType == 'qt1'||eventType == 'qt2'" key="list14" :class="{'active': (eventType == 'qt'||eventType == 'qt1'||eventType == 'qt2')}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    事件记录
                </span>
                </div>
                <div class="modal-body">
                    <Tabs
                            v-model="eventTabIndex"
                            :animated='false'
                            @on-click="eventTabChange"
                    >
                        <TabPane label="报警" name="0">
                            <div class="tab-head">
                                <p class="tab-tit">
                                    报警事件记录
                                </p>
                            </div>
                            <div class="tab-option">
                                <div class="form-wrap modal-form-wrap">
                                    <DatePicker
                                            clearable
                                            transfer :word-wrap="true"
                                            type="daterange"
                                            placeholder="选择时间"
                                            style="width: 150px;"
                                            v-model="selTime"
                                            @on-change="selectTime"
                                    ></DatePicker>
                                    <Select
                                            v-model="selectVal"
                                            transfer :word-wrap="true"
                                            clearable
                                            style="width: 150px;margin-left: 10px;"
                                            placeholder="请选择报警类型"
                                            @on-change="statusSelectFn"
                                    >
                                        <Option
                                                v-for="item in selectArr"
                                                :value="item.code"
                                                :key="item.code"
                                        >
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                    <Select
                                            v-model="handleStatus"
                                            transfer :word-wrap="true"
                                            clearable
                                            style="width: 150px;margin-left: 10px;"
                                            placeholder="处理状态"
                                            @on-change="handleSelectFn"
                                    >
                                        <Option value="0,1">未处理</Option>
                                        <Option value="2">已处理</Option>
                                        <Option value="3">处理中</Option>
                                    </Select>
                                </div>

                                <div class="form-wrap btn-wrap">
                                    <Button type="primary" class="search-btn" @click="btnSearch">搜索</Button>
                                </div>
                            </div>
                            <div class="table-wrap modal-table-wrap">
                                <div class="table-head">
                                    <table>
                                        <tr>
                                            <th width="15%">
                                                报警时间
                                            </th>
                                            <th width="10%">
                                                设备名称
                                            </th>
                                            <th width="10%">
                                                测点名称
                                            </th>
                                            <th width="15%">
                                                报警类型
                                            </th>
                                            <th width="20%">
                                                报警内容
                                            </th>
                                            <th width="10%">
                                                处理状态
                                            </th>
                                            <th width="10%">
                                                处理时间
                                            </th>
                                            <th width="10%">
                                                图片
                                            </th>
                                        </tr>
                                    </table>
                                </div>
                                <div  class="table-body eventScroll">
                                    <table>
                                        <tr v-for="(item, index) in tableTdArr" :key="index">
                                            <td width="15%">
                                                <Poptip
                                                        v-if="item.ctime"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="getDateFn(item.ctime)"
                                                >
                                                    {{getDateFn(item.ctime)}}
                                                </Poptip>
                                            </td>
                                            <td width="10%" >
                                                <Poptip
                                                        v-if="item.deviceName"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.deviceName"
                                                >
                                                    {{item.deviceName}}
                                                </Poptip>
                                            </td>
                                            <td width="10%" >
                                                <Poptip
                                                        v-if="item.pointName"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.pointName"
                                                >
                                                    {{item.pointName}}
                                                </Poptip>
                                            </td>
                                            <td width="15%" >
                                                <Poptip
                                                        v-if="item.typeName"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.typeName"
                                                >
                                                    {{item.typeName}}
                                                </Poptip>
                                            </td>
                                            <td width="20%" >
                                                <Poptip
                                                        v-if="item.content"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.content"
                                                >
                                                    {{item.content}}
                                                </Poptip>
                                            </td>
                                            <td width="10%" >
                                                <Poptip
                                                        v-if="item.state"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.state"
                                                >
                                                    {{item.state}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                        v-if="item.htime"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="getDateFn(item.htime)"
                                                >
                                                    {{getDateFn(item.htime)}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        content="图片"
                                                >
                                                    <i
                                                            class="iconfont imgView"
                                                            :class="{'active': !item.imgPath}"
                                                            @click="showImg(item.imgPath)"
                                                    >
                                                        &#xe635;
                                                    </i>
                                                </Poptip>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                                <div class="loading" v-if="loading_status">
                                    <div class="loading_box" v-show="!tableTdArr.length">
                                        <img :src="tableLoad" />
                                    </div>
                                    <div class="more_data_box" v-show="tableTdArr.length">
                                        <img :src="tableMore" />
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane label="预警" name="1">
                            <div class="tab-head">
                                <p class="tab-tit">
                                    预警事件记录
                                </p>
                            </div>
                            <div class="tab-option">
                                <div class="form-wrap modal-form-wrap">
                                    <DatePicker
                                            clearable
                                            transfer :word-wrap="true"
                                            type="daterange"
                                            placeholder="选择时间"
                                            style="width: 150px;"
                                            v-model="selTime"
                                            @on-change="selectTime"
                                    ></DatePicker>
                                    <Select
                                            v-model="selectVal"
                                            transfer :word-wrap="true"
                                            clearable
                                            style="width: 150px;margin-left: 10px;"
                                            placeholder="请选择预警类型"
                                            @on-change="statusSelectFn"
                                    >
                                        <Option
                                                v-for="item in selectArr"
                                                :value="item.code"
                                                :key="item.code"
                                        >
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                    <Select
                                            v-model="handleStatus"
                                            transfer :word-wrap="true"
                                            clearable
                                            style="width: 150px;margin-left: 10px;"
                                            placeholder="处理状态"
                                            @on-change="handleSelectFn"
                                    >
                                        <Option value="0">未处理</Option>
                                        <Option value="2">已处理</Option>
                                        <Option value="3">处理中</Option>
                                    </Select>
                                </div>

                                <div class="form-wrap btn-wrap">
                                    <Button type="primary" class="search-btn" @click="btnSearch">搜索</Button>
                                </div>
                            </div>
                            <div class="table-wrap modal-table-wrap">
                                <div class="table-head">
                                    <table>
                                        <tr>
                                            <th width="15%">
                                                预警时间
                                            </th>
                                            <th width="10%">
                                                设备名称
                                            </th>
                                            <th width="10%">
                                                测点名称
                                            </th>
                                            <th width="15%">
                                                预警类型
                                            </th>
                                            <th width="20%">
                                                预警内容
                                            </th>
                                            <th width="10%">
                                                处理状态
                                            </th>
                                            <th width="10%">
                                                处理时间
                                            </th>
                                            <th width="10%">
                                                图片
                                            </th>
                                        </tr>
                                    </table>
                                </div>
                                <div class="table-body eventScroll">
                                    <table>
                                        <tr v-for="(item, index) in tableTdArr" :key="index">
                                            <td width="15%">
                                                <Poptip
                                                        v-if="item.ctime"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="getDateFn(item.ctime)"
                                                >
                                                    {{getDateFn(item.ctime)}}
                                                </Poptip>
                                            </td>
                                            <td width="10%" >
                                                <Poptip
                                                        v-if="item.deviceName"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.deviceName"
                                                >
                                                    {{item.deviceName}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                        v-if="item.pointName"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.pointName"
                                                >
                                                    {{item.pointName}}
                                                </Poptip>
                                            </td>
                                            <td width="15%">
                                                <Poptip
                                                        v-if="item.typeName"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.typeName"
                                                >
                                                    {{item.typeName}}
                                                </Poptip>
                                            </td>
                                            <td width="20%" >
                                                <Poptip
                                                        v-if="item.content"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.content"
                                                >
                                                    {{item.content}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                        v-if="item.state"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.state"
                                                >
                                                    {{item.state}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                        v-if="item.htime"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="getDateFn(item.htime)"
                                                >
                                                    {{getDateFn(item.htime)}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        content="图片"
                                                >
                                                    <i
                                                            class="iconfont imgView"
                                                            :class="{'active': !item.imgPath}"
                                                            @click="showImg(item.imgPath)"
                                                    >
                                                        &#xe635;
                                                    </i>
                                                </Poptip>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                                <div class="loading" v-if="loading_status">
                                    <!-- 加载动画 -->
                                    <div class="loading_box" v-show="!tableTdArr.length">
                                        <img :src="tableLoad" />
                                    </div>
                                    <div class="more_data_box" v-show="tableTdArr.length">
                                        <img :src="tableMore" />
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane label="隐患" name="2">
                            <div class="tab-head">
                                <p class="tab-tit">
                                    隐患事件记录
                                </p>
                            </div>
                            <div class="tab-option">
                                <div class="form-wrap modal-form-wrap">
                                    <DatePicker
                                            clearable
                                            transfer :word-wrap="true"
                                            type="daterange"
                                            placeholder="选择时间"
                                            style="width: 150px;"
                                            v-model="selTime"
                                            @on-change="selectTime"
                                    ></DatePicker>

                                    <Select
                                            v-model="handleStatus"
                                            transfer :word-wrap="true"
                                            clearable
                                            style="width: 150px;margin-left: 10px;"
                                            placeholder="处理状态"
                                            @on-change="handleSelectFn"
                                    >
                                        <Option value="0">未处理</Option>
                                        <Option value="2">已处理</Option>
                                        <Option value="3">处理中</Option>
                                    </Select>
                                </div>

                                <div class="form-wrap btn-wrap">
                                    <Button type="primary" class="search-btn" @click="btnSearch">搜索</Button>
                                </div>
                            </div>
                            <div class="table-wrap modal-table-wrap">
                                <div class="table-head">
                                    <table>
                                        <tr>
                                            <th width="20%">
                                                隐患时间
                                            </th>
                                            <th width="20%">
                                                设备名称
                                            </th>
                                            <th width="20%">
                                                隐患内容
                                            </th>
                                            <th width="20%">
                                                处理状态
                                            </th>
                                            <th width="20%">
                                                处理时间
                                            </th>
                                        </tr>
                                    </table>
                                </div>
                                <div class="table-body eventScroll">
                                    <table>
                                        <tr v-for="(item, index) in tableTdArr" :key="index">
                                            <td width="20%">
                                                <Poptip
                                                        v-if="item.createTime"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="getDateFn(item.createTime)"
                                                >
                                                    {{getDateFn(item.createTime)}}
                                                </Poptip>
                                            </td>
                                            <td width="20%" >
                                                <Poptip
                                                        v-if="item.deviceName"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.deviceName"
                                                >
                                                    {{item.deviceName}}
                                                </Poptip>
                                            </td>
                                            <td width="20%" >
                                                <Poptip
                                                        v-if="item.content"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.content"
                                                >
                                                    {{item.content}}
                                                </Poptip>
                                            </td>
                                            <td width="20%" >
                                                <Poptip
                                                        v-if="item.state"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.state"
                                                >
                                                    {{item.state}}
                                                </Poptip>
                                            </td>
                                            <td width="20%">
                                                <Poptip
                                                        v-if="item.htime"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="getDateFn(item.htime)"
                                                >
                                                    {{getDateFn(item.htime)}}
                                                </Poptip>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                                <div class="loading" v-if="loading_status">
                                    <!-- 加载动画 -->
                                    <div class="loading_box" v-show="!tableTdArr.length">
                                        <img :src="tableLoad" />
                                    </div>
                                    <div class="more_data_box" v-show="tableTdArr.length">
                                        <img :src="tableMore" />
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane label="故障" name="3">
                            <div class="tab-head">
                                <p class="tab-tit">
                                    故障事件记录
                                </p>
                            </div>
                            <div class="tab-option">
                                <div class="form-wrap modal-form-wrap">
                                    <DatePicker
                                            clearable
                                            transfer :word-wrap="true"
                                            type="daterange"
                                            placeholder="选择时间"
                                            style="width: 150px;"
                                            v-model="selTime"
                                            @on-change="selectTime"
                                    ></DatePicker>
                                    <Select
                                            v-model="selectVal"
                                            transfer :word-wrap="true"
                                            clearable
                                            style="width: 150px;margin-left: 10px;"
                                            placeholder="请选择故障类型"
                                            @on-change="statusSelectFn"
                                    >
                                        <Option
                                                v-for="item in selectArr"
                                                :value="item.code"
                                                :key="item.code"
                                        >
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                    <Select
                                            v-model="handleStatus"
                                            transfer :word-wrap="true"
                                            clearable
                                            style="width: 150px;margin-left: 10px;"
                                            placeholder="处理状态"
                                            @on-change="handleSelectFn"
                                    >
                                        <Option value="0">未处理</Option>
                                        <Option value="2">已处理</Option>
                                        <Option value="3">处理中</Option>
                                    </Select>
                                </div>

                                <div class="form-wrap btn-wrap">
                                    <Button type="primary" class="search-btn" @click="btnSearch">搜索</Button>
                                </div>
                            </div>
                            <div class="table-wrap modal-table-wrap">
                                <div class="table-head">
                                    <table>
                                        <tr>
                                            <th width="15%">
                                                故障时间
                                            </th>
                                            <th width="15%">
                                                智能部件名称
                                            </th>
                                            <th width="15%">
                                                测点名称
                                            </th>
                                            <th width="10%">
                                                故障类型
                                            </th>
                                            <th width="20%">
                                                故障内容
                                            </th>
                                            <th width="10%">
                                                处理状态
                                            </th>
                                            <th width="15%">
                                                处理时间
                                            </th>
                                        </tr>
                                    </table>
                                </div>
                                <div class="table-body eventScroll">
                                    <table>
                                        <tr v-for="(item, index) in tableTdArr" :key="index">
                                            <td width="15%">
                                                <Poptip
                                                        v-if="item.ctime"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="getDateFn(item.ctime)"
                                                >
                                                    {{getDateFn(item.ctime)}}
                                                </Poptip>
                                            </td>
                                            <td width="15%" >
                                                <Poptip
                                                        v-if="item.deviceName"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.deviceName"
                                                >
                                                    {{item.deviceName}}
                                                </Poptip>
                                            </td>
                                            <td width="15%" >
                                                <Poptip
                                                        v-if="item.pointName"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.pointName"
                                                >
                                                    {{item.pointName}}
                                                </Poptip>
                                            </td>
                                            <td width="10%" >
                                                <Poptip
                                                        v-if="item.typeName"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.typeName"
                                                >
                                                    {{item.typeName}}
                                                </Poptip>
                                            </td>
                                            <td width="20%" >
                                                <Poptip
                                                        v-if="item.content"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.content"
                                                >
                                                    {{item.content}}
                                                </Poptip>
                                            </td>
                                            <td width="10%">
                                                <Poptip
                                                        v-if="item.state"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="item.state"
                                                >
                                                    {{item.state}}
                                                </Poptip>
                                            </td>
                                            <td width="15%">
                                                <Poptip
                                                        v-if="item.htime"
                                                        trigger="hover"
                                                        transfer :word-wrap="true"
                                                        :content="getDateFn(item.htime)"
                                                >
                                                    {{getDateFn(item.htime)}}
                                                </Poptip>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <p v-show="!hasData && !loading_status" class="noData">暂无数据</p>
                                <div class="loading" v-if="loading_status">
                                    <!-- 加载动画 -->
                                    <div class="loading_box" v-show="!tableTdArr.length">
                                        <img :src="tableLoad" />
                                    </div>
                                    <div class="more_data_box" v-show="tableTdArr.length">
                                        <img :src="tableMore" />
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
            <div class="per-info-wrap device-modal modal-list" v-if="(monitorType == 'qt' || monitorType == 'qt1' || monitorType == 'qt2') && partId" key="list15" :class="{'active': (monitorType == 'qt' || monitorType == 'qt1' || monitorType == 'qt2') && partId}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                    <span class="tit">
                        其他设备-联网监控
                    </span>
                </div>
                <div class="modal-body tc_wrap">
                    <div class="modal-body-box">
                        <Row class="modal-body-text">
                            <Col :span="4"><span>{{monitorName}}</span></Col>
                            <Col :span="8"><span>所属建筑:{{monitorBuildingName}}</span></Col>
                            <Col :span="4"><span>所属楼层:{{monitorFloor}}</span></Col>
                        </Row>
                        <Tabs
                                :animated="false"
                                type="card"
                                v-model="tcSelect"
                                v-if="tcNav[0]!='nd'"
                        >
                            <TabPane v-for="item in tcNav" :key="item" :label="tcLabel[item]" :name="item" >
                                <ynd-tem v-if="tcSelect == item && item =='ynd'" :partId="choice.id"></ynd-tem>
                                <ddl-tem v-if="tcSelect == item && item =='ddl'" :partId="choice.id"></ddl-tem>
                            </TabPane>
                        </Tabs>
                        <ndTem v-else :partId="choice.id"></ndTem>
                    </div>
                </div>
            </div>
            <!-- 消防用水 -->
            <div class="per-info-wrap device-modal modal-list" v-if="(monitorType == 'xfs' || monitorType == 'xfs1' || monitorType == 'xfs2') && partId" key="list16" :class="{'active': (monitorType == 'xfs' || monitorType == 'xfs1' || monitorType == 'xfs2') && partId}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                    <span class="tit">
                        消防用水-{{monitorName}}
                    </span>
                </div>
                <div class="modal-body ys_wrap">
                    <div class="modal-body-box">
                        <div class="water_level" id="water_level" v-show="Object.keys(waterLevelObj).length">
                            <div class="border border-top m-b-20 p-l-15 p-r-15 positionRL left">
                                <p class="ys_block_tit">
                                    <span class="bold font14">
                                        <a class="font20">
                                            <img style="width: 16px;vertical-align: middle;"
                                                src="../assets/img/msg/shebei.png">
                                        </a>
                                        <span class="m-l-5">{{waterLevelObj.deviceName}}</span>
                                    </span>
                                    <a class="positionAB font20 colorPrimary" style="right: 15px">
                                        <Icon type="ios-wifi" color="#74D9FF" v-show="waterLevelObj.stateName=='上线'||waterLevelObj.stateName=='正常'||waterLevelObj.stateName=='故障'||waterLevelObj.stateName=='预警'"/>
                                        <img style="width: 18px;vertical-align: middle;margin-top:10px;" :src="baojingPng" v-show="waterLevelObj.stateName=='报警'">
                                        <img style="width: 16px;vertical-align: middle;margin-top:10px;" :src="lixian2Png" v-show="waterLevelObj.stateName=='离线'">
                                    </a>
                                </p>
                                <p class="ys_block_sub_tit">
                                    <span class="font12">
                                        <span class="colorGeneral font16 m-l-3"><Icon type="ios-pin-outline" /></span>
                                        <span class="m-l-10">{{waterLevelObj.buildingName}}</span>
                                    </span>
                                </p>
                                <div style="height: 200px">
                                    <bar-gradient-chart
                                        :id="`bar-gradient-chart-${0}`"
                                        :height="'200px'"
                                        :y="waterLevelObj.value?[waterLevelObj.value]:[]"
                                        :ymax="waterLevelObj.height||0"
                                        :minline="waterLevelObj.lowAlarmValue||0"
                                        :maxline="waterLevelObj.highAlarmValue||[]"
                                    ></bar-gradient-chart>
                                </div>
                                <div class="bottomCard" style="padding-bottom:26px">
                                    <div>
                                        <img style="width: 24px;" src="@/assets/img/network-monitor/xfrj.png">
                                        <span>容积:{{waterLevelObj.capacity ? waterLevelObj.capacity : '~'}} m<sup>3</sup></span>

                                    </div>
                                    <div>
                                        <img style="width: 24px;" src="@/assets/img/network-monitor/xfsw.png">
                                        <span>实际水位:{{waterLevelObj.value ? waterLevelObj.value : '~'}} m</span>

                                    </div>
                                    <div>
                                        <img style="width: 24px;" src="@/assets/img/network-monitor/swzb.png">
                                        <span>水位占比:{{waterLevelObj.waterRatio ? waterLevelObj.waterRatio : '~'}} %</span>


                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="water_pressure" id="water_pressure" v-show="Object.keys(waterPressure).length">
                            <div class="border border-top m-b-20 p-l-15 p-r-15 positionRL left">
                                <p class="ys_block_tit">
                                    <span class="bold font14">
                                        <a class="font20">
                                            <img style="width: 16px;vertical-align: middle;"
                                                src="../assets/img/msg/shebei.png">
                                        </a>
                                        <span class="m-l-5">{{waterPressure.deviceName}}</span>
                                    </span>
                                    <a class="positionAB font20 colorPrimary" style="right: 15px">
                                        <Icon type="ios-wifi" color="#74D9FF" v-show="waterPressure.stateName=='上线'||waterPressure.stateName=='正常'||waterPressure.stateName=='故障'||waterPressure.stateName=='预警'"/>
                                        <img style="width: 18px;vertical-align: middle;margin-top:10px;" :src="baojingPng" v-show="waterPressure.stateName=='报警'">
                                        <img style="width: 16px;vertical-align: middle;margin-top:10px;" :src="lixian2Png" v-show="waterPressure.stateName=='离线'">
                                    </a>
                                </p>
                                <p class="ys_block_sub_tit">
                                    <span class="font12">
                                        <span class="colorGeneral font16 m-l-3"><Icon type="ios-pin-outline" /></span>
                                        <span class="m-l-10">{{waterPressure.buildingName}}</span>
                                    </span>
                                </p>
                                <div style="height: 200px">
                                    <series-gauge-chart
                                        :id="`series-gauge-chart-${1}`"
                                        :height="'200px'"
                                        :x="waterPressure.value?[waterPressure.value]:0"
                                        :minline="waterPressure.lowAlarmValue||0"
                                        :maxline="waterPressure.highAlarmValue||0"
                                    ></series-gauge-chart>
                                </div>
                                <div class="bottomCard">
                                    <div>
                                        <i style="font-size: 18px;color: #2BD9E2;margin-right: 5px">Min</i>
                                        <span>报警值:{{waterPressure.lowAlarmValue ? waterPressure.lowAlarmValue : '~'}} Mpa</span>
                                    </div>
                                    <div>
                                        <img style="width: 16px;" src="@/assets/img/network-monitor/xfsjsy.png">
                                        <span>实际水压:{{waterPressure.value ? waterPressure.value : '~'}} Mpa</span>

                                    </div>
                                    <div>
                                      <i style="font-size: 18px;color: #2BD9E2;margin-right: 5px">Max</i>
                                        <span>报警值:{{waterPressure.highAlarmValue ? waterPressure.highAlarmValue : '~'}} Mpa</span>


                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- 水泵 -->
                        <div class="water_pump" id="water_pump"  v-if="Object.keys(waterPump).length">
                            <fp-pump :partId="choice.id"></fp-pump>
                        </div>
                        <!--消防水泵-->
                         <Tabs :animated="false" type="card"  v-model="tcSelect" v-if="tcNav.length>0">
                            <TabPane v-for="item in tcNav" :key="item" :label="tcLabel[item]" :name="item" >
                                <ztTem v-if="tcSelect == item && item=='zt'" :partId="choice.id"></ztTem>
                                <wit-control-Xfs v-if="tcSelect == item && item =='kz'" :id="choice.id"></wit-control-Xfs>
                                <xfsDlTem v-if="tcSelect == item && item =='dl'" :type="'dl'" :partId="choice.id"></xfsDlTem>
                                <xfsDlTem v-if="tcSelect == item && item =='sw'" :type="'sw'" :partId="choice.id"></xfsDlTem>
                                <xfsDlTem v-if="tcSelect == item && item =='sy'" :type="'sy'" :partId="choice.id"></xfsDlTem>
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </div>
            <!-- 独立式探测器 自动灭火 -->
            <div class="per-info-wrap device-modal modal-list" v-if="(monitorType == 'tc' || monitorType == 'tc1' || monitorType == 'tc2'||monitorType == 'zdmh' || monitorType == 'zdmh1' || monitorType == 'zdmh2') && partId" key="list17" :class="{'active': (monitorType == 'tc' || monitorType == 'tc1' || monitorType == 'tc2') && partId}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                    <span class="tit" v-if="monitorType == 'tc' || monitorType == 'tc1' || monitorType == 'tc2'">
                        独立式探测器-{{monitorName}}
                    </span>
                     <span class="tit" v-else>
                        自动灭火系统-{{monitorName}}
                    </span>
                </div>
                <div class="modal-body tc_wrap tcqpartsty" v-if="tcqpartTypeCode == 94">
                  <div class="fire_pump">
                      <div class="fire_tit">
                          <span>{{tcName}}</span>
                          <img :src="stateActive(tcstateName)?lineImg:offlineImg"/>
                      </div>
                      <div class="fire_pump_one">
                          <div class="fire_pump_one_atem" v-for="(items,indexs) in list.kg" :key="indexs">
                              <span class="fire_pump_one_atem_span">{{items.name}}</span>
                              <img v-if="items.pointTypeCode=='20416'" :src="items.pointValue==1?runImg:items.pointValue==0?closeImg:''"/>
                              <img v-if="items.pointTypeCode=='20417'" :src="items.pointValue==1?stopImg:items.pointValue==0?closeImg:''"/>
                              <img v-if="items.pointTypeCode=='20410'" :src="items.pointValue==1?faultImg:items.pointValue==0?closeImg:''"/>
                          </div>
                      </div>
                      <div class="fire_pump_two">
                          <div class="fire_pump_two_atem" v-for="(itemss,indexss) in list.mnl" :key="indexss">
                              <p class="fire_pump_two_atem_p">{{itemss.name}}</p>
                              <div>
                                  <span>{{itemss.pointValue}}</span>
                                  <img class="fire_pump_two_atem_img" :src="pumpCurveImg" @click="curveEvent(tcId,itemss.id,itemss.name)"/>
                              </div>
                          </div>
                      </div>
                      <div class="fire_pump_three">
                          <span class="fire_pump_three_span">{{list.gz.name}}</span>
                          <img class="fire_pump_three_img" v-if="list.gz.pointTypeCode=='20410'" :src="list.gz.pointValue==1?faultImg:list.gz.pointValue==0?closeImg:''"/>
                      </div>
                      <div class="fire_pump_four">
                          <img v-if="list.zs.pointTypeCode == '20406'" class="fire_pump_four_img" :src="pumpManualImg"/>
                          <img v-else-if="list.zs.pointTypeCode == '20407'" class="fire_pump_four_img" :src="pumpAutoImg"/>
                          <span v-else class="fire_pump_four_span">{{list.zs.pointValue}}</span>
                      </div>
                  </div>

                    <Modal
                            v-model="modal1"
                            :title="pointName+'监测曲线'"
                            :footer-hide="true"
                            class="curve"
                    >
                        <Row>
                            <Col span="1" class="select-label">
                            <span style="height: 32px;line-height: 32px;">选择日期</span>
                            </Col>
                            <Col span="4">
                            <DatePicker type="date" v-model="pointTime" placeholder="请输入时间" style="width: 200px" @on-change="pointTimeChange"></DatePicker>
                            </Col>
                        </Row>
                        <p v-if="chartList.length==0" class="midTip">{{curvnState}}</p>
                        <div id="mainline" style="width: 500px;height: 300px"></div>
                    </Modal>

                </div>
                <div class="modal-body tc_wrap" v-else>
                      <div class="modal-body-box">
                          <Tabs
                              :animated="false"
                              type="card"
                              v-model="tcSelect"
                              v-if="tcNav[0]!='nd'"
                          >
                              <TabPane v-for="item in tcNav" :key="item" :label="tcLabel[item]" :name="item" >
                                  <ynd-tem v-if="tcSelect == item && item =='ynd'" :partId="choice.id"></ynd-tem>
                                  <ddl-tem v-if="tcSelect == item && item =='ddl'" :partId="choice.id"></ddl-tem>
                                  <zdmhDlTem v-if="tcSelect == item && item =='dl'" :type="'dl'" :partId="choice.id"></zdmhDlTem>
                                  <zdmhDlTem v-if="tcSelect == item && item =='wd'" :type="'wd'" :partId="choice.id"></zdmhDlTem>
                                  <zdmhDlTem v-if="tcSelect == item && item =='sd'" :type="'sd'" :partId="choice.id"></zdmhDlTem>
                                  <zdmhXqdTem v-if="tcSelect == item && item =='xqd'" :partId="choice.id"></zdmhXqdTem>
                                  <zdmhZtTem v-if="tcSelect == item && item=='zt'" :partId="choice.id"></zdmhZtTem>
                              </TabPane>
                          </Tabs>
                          <nd-tem v-else :partId="choice.id"></nd-tem>
                      </div>
                </div>
            </div>
            <!-- 设备总体情况详情 -->
            <!-- 事件记录 -->
            <div class="per-info-wrap modal-list" v-if="showDetail" key="list18" :class="{'active': showDetail}">
                <div class="modal-head">
                  <span class="tit">
                    {{deviceModel.name}}详情
                  </span>
                  <img :src="close" @click="closeModal" alt="">
                </div>
                <div class="modal-body modal-form-wrap">
                    <Form ref="addForm" :model="deviceModel" :rules="deviceRules" :label-width="130">
                        <mask-title :txt="'必填信息'"></mask-title>
                        <Row :gutter="16">
                            <Col span="10">
                                <FormItem label="设施名称" prop="name">
                                    <Input :disabled="true" v-model="deviceModel.name" placeholder=""></Input>
                                </FormItem>
                            </Col>
                            <Col span="10">
                                <FormItem label="所属建筑" prop="buildingName">
                                    <Input :disabled="true" v-model="deviceModel.buildingName" placeholder=""></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            <Col span="10">
                                <FormItem label="所属重点部位" prop="impPositionName">
                                    <Input  :disabled="true" v-model="deviceModel.impPositionName"></Input>
                                </FormItem>
                            </Col>
                            <Col span="10">
                                <FormItem label="所属设施" prop="parentDeviceName">
                                    <Input  :disabled="true" v-model="deviceModel.parentDeviceName"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            <Col span="10">
                                <FormItem label="设施系统形式" prop="systemFormName">
                                    <Input  :disabled="true" v-model="deviceModel.systemFormName"></Input>
                                </FormItem>
                            </Col>
                            <Col span="10">
                                <FormItem label="设施系统类型" prop="deviceTypeName">
                                    <Input  :disabled="true" v-model="deviceModel.deviceTypeName"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            <Col span="10">
                                <FormItem label="设施型号" prop="model">
                                    <Input :disabled="true" v-model="deviceModel.model" placeholder=""></Input>
                                </FormItem>
                            </Col>
                            <Col span="10">
                                <FormItem label="楼层号" prop="floor">
                                    <Input placeholder="" :disabled="true" style="width: 100%" :step="0"
                                        v-model="deviceModel.floor"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            <Col span="10">
                                <FormItem label="设施服务状态" prop="serverStateName">
                                    <Input  :disabled="true" v-model="deviceModel.serverStateName"></Input>
                                </FormItem>
                            </Col>
                            <Col span="10">
                                <FormItem label="设施状态" prop="eventStateName">
                                    <Input  :disabled="true" v-model="deviceModel.eventStateName"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            
                            <Col span="10">
                                <FormItem label="状态变化时间" prop="serverStateChangeTime">
                                    <Input placeholder="" :disabled="true" v-model="deviceModel.serverStateChangeTime"></Input>
                                </FormItem>
                            </Col>
                            <Col span="10">
                                <FormItem label="生产单位" prop="manufacturer">
                                    <Input placeholder="" :disabled="true" v-model="deviceModel.manufacturer"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            
                            <Col span="10">
                                <FormItem label="生产单位电话" prop="manufacturerTel">
                                    <Input placeholder="" :disabled="true" v-model="deviceModel.manufacturerTel"></Input>
                                </FormItem>
                            </Col>
                            <Col span="10">
                                <FormItem label="维修保养单位" prop="maintenance">
                                    <Input placeholder="" :disabled="true" v-model="deviceModel.maintenance"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            
                            <Col span="10">
                                <FormItem label="维修保养单位电话" prop="maintenanceTel">
                                    <Input placeholder="" :disabled="true" v-model="deviceModel.maintenanceTel"></Input>
                                </FormItem>
                            </Col>
                            <Col span="10">
                                <FormItem label="绑定摄像头名称" prop="cameraName">
                                    <Input placeholder="" :disabled="true" v-model="deviceModel.cameraName"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            
                            <Col span="10">
                                <FormItem label="投入使用时间" prop="serviceTime">
                                    <Input placeholder="" :disabled="true" v-model="deviceModel.serviceTime"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
            <!-- 消防运行情况，地图定位 -->
            <div class="per-info-wrap modal-list" v-if="showMap" key="list19" :class="{'active': showMap}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    定位
                </span>
                </div>
                <div class="modal-body">
                    <div id="xf_map"></div>
                </div>
            </div>
            <!-- 消防运行情况，事件定位 -->
            <div class="per-info-wrap modal-list" v-if="showCrtMap" key="list19" :class="{'active': showCrtMap}">
                <div class="modal-head">
                  <img :src="close" @click="closeModal" alt="">
                <span class="tit">
                    定位
                </span>
                </div>
                <div class="page-content">
                    <iframe class="map-iframe" :src="iframeCrtSrc" width="100%" height="100%" frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" allowtransparency="yes"></iframe>
                </div>
            </div>
        </transition>
        <Modal
            v-model="modalStatus"
            :closable="true"
            width="800"
            title="火灾自动报警系统平面图"
            class="baseInfo-modal"
            :footer-hide="true"
        >
            <div>
                <img width="100%" :src="defaultList.length ? defaultList[0]['url'] :'' " alt="">
            </div>
        </Modal>
        <Modal
                v-model="modalShow"
                :closable="true"
                width="800"
                class="baseInfo-modal"
                :footer-hide="true"
        >
            <img class="modalImg" :src="modalImgSrc" alt="">
        </Modal>


         <Modal :footer-hide="true" title="图片查看" v-model="imgModal" width="680">
      <div style="text-align: center;">
        <img :src="previewSrc" alt style="width: 500px;display: inline-block;" />
      </div>
    </Modal>
    </div>
</template>
<script>
    import EZUIKit from "ezuikit-js";
    import videoPlay from './videoPlay/videoPlay.vue'
    import hkVideo from "./videoPlay/hkVideo/hkVideo.vue";
    import h5Video from "./videoPlay/h5Video/h5Video.vue";
    import {
        userList,
        importantParts,
        buildings,
        buildingDocuments,
        surroundInfo,surroundInfo1,surroundInfo2,surroundInfo3,surroundInfo4,surroundInfo5,surroundInfo6,surroundInfo7,
        reservePlan,
        camerasMonitor,
        importantPartType,
        eduInfo,
        contBlockUrl
    } from '@/assets/js/url.js';
    import {getDate} from '@/assets/js/tools';
    import close from '@/assets/img/close.png';
    import iconcamera from '@/assets/img/iconcamera.png';
    import videojs from 'video.js'
    import maskTitle from './mask-title.vue';
    import logoUpload from './logo-upload.vue';
    import baojingPng from '@/assets/img/msg/baojing.png';
    import lixian2Png from '@/assets/img/msg/lixian2.png';
    // 消防水
    import barGradientChart from '@/components/bar-gradient.vue';
    import seriesGaugeChart from '@/components/series-gauge.vue';
    import fpPump from './fp/fire-pump.vue';
    import ztTem from './xfs/zt.vue';
    import xfsDlTem from './xfs/dl.vue';
    import witControlXfs from './xfs/wit-control-xfs';

    // 独立探测器
    import yndTem from './detector/ynd.vue';
    import ddlTem from './detector/ddl.vue';
    import ndTem from './detector/nd.vue';

    //自动灭火系统
    import zdmhDlTem from './zdmh/dl.vue';
    import zdmhXqdTem from './zdmh/xqd.vue';
    import zdmhZtTem from './zdmh/zt.vue';

    // 电气火灾监控
    import witElectricTemperature from './wit-electric-monitor/wit-electric-temperature';
    import witElectricLoad from './wit-electric-monitor/wit-electric-load';
    import witElectricCreepage from './wit-electric-monitor/wit-electric-creepage';
    import witElectricVoltage from './wit-electric-monitor/wit-electric-voltage';
    import witElectricCurrent from './wit-electric-monitor/wit-electric-current';
    import witElectricRate from './wit-electric-monitor/wit-electric-rate';
    import witElectricStatus from './wit-electric-monitor/wit-electric-status';
    import witControl from './wit-electric-monitor/wit-control';


    //巡检任务
    import riskRecord from './riskRecord/riskRecord';
    import marker3Img from '@/assets/marker/ico3.png'; //单位图标

    import tableLoad from '@/assets/img/animation.gif';
    import tableMore from '@/assets/img/animation.gif';

    import runImg from '@/assets/images/base_layer_img/pump_run.png';
    import closeImg from '@/assets/images/base_layer_img/pump_close.png';
    import stopImg from '@/assets/images/base_layer_img/pump_stop.png';
    import faultImg from '@/assets/images/base_layer_img/pump_fault.png';
    import lineImg from '@/assets/images/base_layer_img/pump_line.png';
    import offlineImg from '@/assets/images/base_layer_img/pump_offline.png';
    import pumpManualImg from '@/assets/images/base_layer_img/pump_manual.png';
    import pumpAutoImg from '@/assets/images/base_layer_img/pump_auto.png';
    import pumpCurveImg from '@/assets/images/base_layer_img/pump_curve.png';
    export default {
        name: "",
        data: () => ({
            curvnState:'',
            chartList:[],
            runImg,
            closeImg,
            stopImg,
            faultImg,
            lineImg,
            offlineImg,
            pumpManualImg,
            pumpAutoImg,
            pumpCurveImg,
            modal1:false,
            pointTime:null,
            pointName:'',
            tcqpartTypeCode:'',
            list:{
                kg:[],
                mnl:[],
                gz:{},
                zs:{}
            },
            tcstateName:'',
            tcName:'',
            tcId:null,
            deveceid:'',
            pointId:'',
            monitorFloor:'',
            monitorBuildingName:'',
            loading_status: false,
            tableLoad,
            accessToken:'',
            cameraModel:{},
            videoSrc:'',
            videoDeviceId: "",
            channelNum:"",
            videoSid:"",
            tableMore,
            tableInitStatus: false,
            marker3Img,
            tabsSelect: '',
            tabList: [],
            module:{
                'fh':'负荷',
                'dl':'电流',
                'dy':'电压',
                'gl':'功率因数',
                'wd':'温度',
                'ld':'漏电',
                'zt':'状态',
                'kz':'控制',
                'xqd':'信号强度',
                'sd':'湿度'
            },
            tcSelect: '',
            tcNav:[],
            tcLabel: {
                "ynd":'烟雾浓度',
                "ddl": '电池电量',
                'nd': '浓度',
                'xqd':'信号强度',
                'sd':'湿度',
                'zt':'状态',
                'dl':'电流',
                'wd':'温度',
                'sw':'水位',
                'sy':'水压',
                'kz':'控制'
            },
            zbzyList:[
                {
                    name:'危险品',
                    code:'1'
                },
                {
                    name:'加油站',
                    code:'2'
                },
                {
                    name:'周边水源',
                    code:'3'
                },
                {
                    name:'出入口',
                    code:'4'
                },
                {
                    name:'避难地',
                    code:'5'
                },
                {
                    name:'限高杆',
                    code:'6'
                },
                {
                    name:'微型消防站',
                    code:'7'
                }
            ],
            lixian2Png,
            baojingPng,
            partId: '',
            waterLevelObj: {},
            waterPressure: {},
            waterPump: {},
            choice: {
                id: ''
            },
            iframeSrc:'',
            iframeCrtSrc:'',
            videoArr: [],
            xf_map: null,
            huoTypeList:[
                {
                    code:"207",
                    name:'感烟报警',
                    key:0
                },
                {
                    code:"209",
                    name:'气体浓度高报警',
                    key:1
                },
                {
                    code:"208",
                    name:'手动报警',
                    key:2
                },
                {
                    code:"205,807",
                    name:'报警',
                    key:3
                }
            ],
            selTime: null,
            modalShow: false,
            modalImgSrc: '',
            layerItem: {},
            searchVal: '',
            selectVal: '',
            selectGetStatus: true,
            selectArr: [
                {
                    name: '',
                    code: ''
                }
            ],
            handleStatus: '',
            handleGetStatus: true,
            eventType: '',
            monitorType: '', //实时监测类型
            monitorName: '', //实时监测设备名称
            defaultList: [],
            modalStatus: false,
            deviceModel: {},
            deviceRules: {},
            layerDeviceName: '',
            eventTid: '',
            eventTabIndex: '0',
            eventTabName: 'fire',
            hasData: false,
            surroundingResources: '1',
            beginTime: undefined,
            endTime: undefined,
            inpBuildingId: '', //重点部位名称
            inpImportantPartType: '', //重点部位类型
            loginData: '',
            hashValue: '',
            close,
            iconcamera,
            inpVal: '',
            select1Val: '',
            detailLayerIndex: '',
            resources1Index: 0,
            tableTdArr: [], //弹窗table列表
            resources1Arr: [
                {
                    name: '微型消防站',
                    val: '4'
                },
                {
                    name: '消防队',
                    val: '5'
                },
            ],
            resources2Index: 0,
            resources2Arr: [
                {
                    name: "周边医院",
                    val: '9'
                },
                {
                    name: '重点通信设施',
                    val: '10'
                },
                {
                    name: '避难地',
                    val: '6'
                },
                {
                    name: '水源信息',
                    val: '11'
                },
                {
                    name: '周边道路',
                    val: '7'
                },
                {
                    name: '出入口',
                    val: '8'
                },
            ],
            resources3Index: 0,
            resources3Arr: [
                {
                    name: '燃气管道',
                    val: '15'
                },
                {
                    name: '人员密集场所',
                    val: '16'
                },
                {
                    name: '危险品',
                    val: '12'
                },
                {
                    name: '交通枢纽',
                    val: '17'
                },
                {
                    name: '加油站',
                    val: '13'
                },
                {
                    name: '限高物',
                    val: '14'
                },
            ],
            resourceType: 4,
            currentPage: 1,
            pageSize: 50,
            videoType:"1",
            currentPage1: 1,
            pageSize1: 12,
            totalCount: '',
            ownerBuildList: [],//建筑类别
            importTypeList: [],//重点部位类型
            formValidate: {},
            ruleValidate: {
            },
            currentVideoId: '',     // 当前鼠标移入的id
            videoPlayerList: {},
            cardTotalCount: 0,
            cardList:[],    // 卡片列表
            camera: false,
            player: null,
            eduInfoArr: [],
            //演练结果
            select: {
                result: [
                    {
                        label: '不合格',
                        value: 0
                    },
                    {
                        label: '合格',
                        value: 1
                    }
                ]
            },
            //演练内容
            yanlianList:{
                title:'',
                requirements:'',
                beginTime:'',
                endTime:'',
                assignDepName:'',
                content:'',
                result:'',
                orgName:'',
                overtimeFlag:'',
                doneTaskVOS:[{
                    overtimeFlag: undefined,       //培训是否超时
                    result: undefined,              //演练结果
                    filePaths: [],
                    assignDepName: '',   
                    assignOrgName: '',         //培训内容 // 下发单位
                    fileName: ''
                }]
            },
            //培训内容
            peixunList:{
                title:'',
                beginTime:'',
                endTime:'',
                content:'',
                doneTaskVOS:[{
                    overtimeFlag: undefined,       //培训是否超时
                    percentRate: undefined,        //合格率
                    joiningRate: undefined,        //参加率
                    filePaths: [],                  //培训照片
                    fileName: ''
                }]
            },
            previewSrc:'',
            imgModal:false
        }),
        props:{
            optionBtnIndex:'',
            taskId:'',
            deviceId:'',
            deviceName:''
        },
        watch: {
            optionBtnIndex: {
                handler(newVal, oldVal) {
                    if (typeof newVal != 'string') { //显示对应的弹窗
                        this.detailLayerIndex = '';
                        this.iframeSrc = '';
                        this.surroundingResources = '1';
                        this.dataInit();
                        if(this.optionBtnIndex == 7){//单位立面图
                            this.iframeSrc = window.localStorage.getItem("crt_url") +'/build-track?orgName=' + this.loginData.orgName + '&orgId=' + this.$store.state.baseInfoLayer.baseInfoId + '&phone=' + this.loginData.loginName + '&pass=' + window.localStorage.getItem('hashValue') + '&appCode=runWatchScreen' + '&token=' + window.localStorage.getItem('randVal_token')
                            console.log(this.iframeSrc);
                        }else if(this.optionBtnIndex == 6){
                            this.getToken()
                            this.getCamerasMonitor();
                        }else if(this.optionBtnIndex == 8){
                            this.getYanLianData();
                        }else if(this.optionBtnIndex == 9){
                            this.getPxData();
                        }else{
                            this.getListData();
                            this.getOwnerBuild();
                            this.getImportType();
                        }
                    } else { //空

                    }
                },
                immediate: true,
                deep: true
            },
             
            eventStatis: {
                handler(newVal, oldVal){
                    if(newVal){
                        console.log(this.$store.state.eventStatis.id);
                        this.eventType = this.$store.state.eventStatis.type;
                        this.layerItem = this.$store.state.eventStatis.item;
                        this.dataInit();
                        this.getSelect();
                        this.getEventsTable();
                    }else {
                        this.eventType = '';
                    }
                },
                immediate: true,
                deep: true
            },
            showDetail: {
                handler(newVal, oldVal){
                    this.deviceModel = {};
                    // if($('.modal-body').length){
                    //     $('.modal-body').mCustomScrollbar('destroy');
                    // }
                    if(newVal){
                        console.log(this.$store.state.showDetail.item);
                        console.log('详情');
                        this.layerDeviceName = this.$store.state.showDetail.item.name;
                        this.dataInit();
                        this.getDeviceDetail();
                    }
                },
                immediate: true,
                deep: true
            },
            showMap: {
                handler(newVal, oldVal){
                    if(newVal){
                        console.log(this.$store.state.showMap.position);
                        console.log('地图定位位置');
                        this.$nextTick(()=>{
                            this.mapInit(this.$store.state.showMap.position);
                        });
                    }
                },
                immediate: true,
                deep: true
            },
            showCrtMap: {
                handler(newVal, oldVal){
                    if(newVal){
                        let deviceId;
                        this.$store.state.showCrtMap.item.sourceType == 0 ? deviceId = this.$store.state.showCrtMap.item.deviceId : deviceId = this.$store.state.showCrtMap.item.partId
                        this.iframeCrtSrc = window.localStorage.getItem("crt_url") +'/crt-track?orgName=' + this.loginData.orgName + '&orgId=' + this.$store.state.baseInfoLayer.baseInfoId + '&phone=' + this.loginData.loginName + '&pass=' + window.localStorage.getItem('hashValue') + '&appCode=runWatchScreen' + '&token=' + window.localStorage.getItem('randVal_token') + '&buildingId=' + this.$store.state.showCrtMap.item.buildingId + '&floor=' + this.$store.state.showCrtMap.item.floor + '&sourceType=' + this.$store.state.showCrtMap.item.sourceType + '&deviceId=' + deviceId + '&schema=2'
                    }
                },
                immediate: true,
                deep: true
            },
            monitorId: { //实时监测
                handler(newVal, oldVal){
                    this.monitorType = '';
                    this.monitorName = '';
                    this.monitorBuildingName = '';
                    this.monitorFloor = '';
                    this.partId = '';
                    this.waterPump = {};
                    this.waterLevelObj = {};
                    this.waterPressure = {};
                    this.loading_status = false;
                    this.hasData = false;
                    console.log(newVal);

                    if(!!newVal){
                        this.monitorType = this.$store.state.monitor.type;
                        this.monitorName = this.$store.state.monitor.item.deviceName;
                        this.tcqpartTypeCode = this.$store.state.monitor.item.partTypeCode;
                        this.tcName = this.$store.state.monitor.item.name;
                        this.tcstateName = this.$store.state.monitor.item.stateName;
                        this.tcId = this.$store.state.monitor.item.id;
                        this.monitorBuildingName = this.$store.state.monitor.item.buildingName;
                        this.monitorFloor = this.$store.state.monitor.item.floor;
                        this.partId = newVal;
                        this.choice.id = newVal;
                        // 消防水设备
                        if(this.monitorType == 'xfs' || this.monitorType == 'xfs1' || this.monitorType == 'xfs2'){
                            this.tcNav=[]
                            if(this.$store.state.monitor.item.deviceTypeSid == '36540109'){ //水泵
                                // this.waterPump = dataObj;
                                this.getTcNav();
                                this.$nextTick(()=>{
                                    // $('#water_pump').mCustomScrollbar();
                                });
                            }else{ //请求水位水压数据
                                
                                this.getYsEchart(this.$store.state.monitor.item.stateName);
                            }
                        }else if(this.monitorType == 'tc' || this.monitorType == 'tc1' || this.monitorType == 'tc2'){ //独立探测器
                            if(this.tcqpartTypeCode == 94){
                                this.getMeasuringPoint(this.$store.state.monitor.item.id);
                            }else{
                                this.getTcNav();
                            }
                        }else if(this.monitorType == 'zdmh' || this.monitorType == 'zdmh1' || this.monitorType == 'zdmh2'){ //自动灭火系统
                            this.getTcNav();
                        }
    //其他设备
                        else if(this.monitorType == 'qt' || this.monitorType == 'qt1' || this.monitorType == 'qt2'){
                            this.getTcNav();
                        }
                        else if(this.monitorType == 'dq' || this.monitorType == 'dq1' || this.monitorType == 'dq2'){ //电气火灾监控
                            this.getYdEchart();
                        }
                    }
                },
                immediate: true,
                deep: true
            }
        },
        components: {
            logoUpload,
            videoPlay,
            hkVideo,
            h5Video,
            maskTitle,
            barGradientChart,
            seriesGaugeChart,
            fpPump,
            yndTem,
            ddlTem,
            ndTem,
            witElectricTemperature,
            witElectricCreepage,
            witElectricVoltage,
            witElectricCurrent,
            witElectricRate,
            witElectricStatus,
            witElectricLoad,
            witControl,
            riskRecord,
            zdmhDlTem,
            zdmhXqdTem,
            zdmhZtTem,ztTem,witControlXfs,xfsDlTem
        },
        created() {
        },
        mounted() {
            this.hashValue = window.localStorage.getItem('hashValue');
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
            $JQ('.per-info-wrap:visible .detail-info-layer .detail-body-wrap').mCustomScrollbar();

        },
        updated () {
            this.$nextTick(()=>{
                if(this.tableInitStatus){
                    console.log('表格加载完成');
                    if(this.eventType){ //事件记录
                        $JQ('.eventScroll:visible').mCustomScrollbar();
                    }else {
                        $JQ('.mCustomScrollbar1:visible').mCustomScrollbar();
                    }
                }
                if(this.monitorId){
                    if($JQ('.per-info-wrap:visible .modal-body-box .ivu-tabs-content .ivu-tabs-tabpane:visible').length){
                        $JQ('.per-info-wrap:visible .modal-body-box .ivu-tabs-content .ivu-tabs-tabpane:visible').mCustomScrollbar();
                    }
                }
            });
        },
        computed: {
            eventStatis(){
                return this.$store.state.eventStatis.status;
            },
            showDetail(){
                return this.$store.state.showDetail.status;
            },
            showMap(){
                return this.$store.state.showMap.status;
            },
            showCrtMap(){
                return this.$store.state.showCrtMap.status;
            },
            monitorId(){
                return this.$store.state.monitor.id;
            }
        },
        methods: {
            stateActive(name){
                let arr = ['正常','故障','预警','报警','上线',]
                if(arr.indexOf(name) > -1){
                    return true
                }
                return false
            },
             previewImg(val) {
                   if(!val){
                    return;
                }
                this.imgModal = true;
                this.previewSrc = val;
                },
            pointTimeChange(val){
                this.pointTime=val;
                this.setChart();
            },
            getYdEchart(){
                let url = `/mcbw/network_monitor/pointTypes/${this.partId}`;
                let _this = this;
                var data = {
                    type: 'get',
                    url: url,
                    obj: {
                        orgId: this.$store.state.baseInfoLayer.baseInfoId,
                    }
                };
                _this.$Axios(data).then((res) => {
                    console.log(res);
                    console.log('电气火灾监控');

                    if (res.data.success && res.data.data.length) {
                        for(let i = 0; i < res.data.data.length; i++){
                            if(!this.module[res.data.data[i]]){
                                // console.log(i);
                                // console.log(res.data.data[i]);
                                res.data.data.splice(i,1);
                            }
                        }

                        // console.log(res.data.data);

                        this.tabList = res.data.data;
                        this.tabsSelect = res.data.data[0];

                        // this.$nextTick(()=>{
                        //     $('.modal-body-box .ivu-tabs-content').mCustomScrollbar();
                        // });
                    }
                })
            },
            getTcNav(){
                // 获取导航数据
                this.tcNav = [];
                let url = '/mcbw/network_monitor/pointTypes/' + this.partId;
                let _this = this;
                var data = {
                    type: 'get',
                    url: url,
                    obj: {
                        orgId: this.$store.state.baseInfoLayer.baseInfoId,
                    }
                };
                _this.$Axios(data).then((res)=>{
                    console.log(res);
                    console.log('导航数据');
                    if(res.data.success && res.data.data.length){
                        for(let i = 0; i< res.data.data.length; i++){
                            //if(res.data.data[i] == 'ynd' || res.data.data[i] == 'ddl' || res.data.data[i] == 'nd'|| res.data.data[i] == 'zt'|| res.data.data[i] == 'xqd'|| res.data.data[i] == 'dl'){
                                this.tcNav.push(res.data.data[i]);
                            //}
                        }
                        this.tcSelect = this.tcNav[0];
                    }
                    console.log(this.tcNav);

                    // this.$nextTick(()=>{
                    //     $('.modal-body-box .ivu-tabs-content').mCustomScrollbar();
                    // });
                });
            },
            getYsEchart(stateName){ //获取用水echart数据
                // 正常 5；故障4；预警3；报警2；上线0；离线1
                let partStateCode = '';
                switch (stateName) {
                    case '上线':
                        partStateCode = 0;
                        break;
                    case '离线':
                        partStateCode = 1;
                        break;
                    case '报警':
                        partStateCode = 2;
                        break;
                    case '预警':
                        partStateCode = 3;
                        break;
                    case '故障':
                        partStateCode = 4;
                        break;
                    case '正常':
                        partStateCode = 5;
                        break;
                }
                let _this = this;
                let url = '/mcbw/network_monitor/water/' + this.partId;
                var data = {
                    type: 'get',
                    url: url,
                    obj: {
                        orgId: this.$store.state.baseInfoLayer.baseInfoId,
                        "pageSize":1000,
                        "currentPage":1,
                        "name":"",
                        "sort":"2",
                        "pointType":"",
                        "partStateCode": partStateCode
                    }
                };
                _this.$Axios(data).then((res) => {
                    console.log(res);
                    console.log('水位水压数据');
                    console.log(res.data.data[0].deviceTypeSid == '36540109' ? '水泵' : '水压水位');

                    if(res.data.success && res.data.data.length){
                        if(res.data.data[0].pointType == '11001'){ //水位 11001
                            this.waterLevelObj = res.data.data[0];
                        }else{ //水压 11101
                            this.waterPressure = res.data.data[0];
                        }
                    }

                    // this.$nextTick(()=>{
                    //     $('.modal-body-box .ivu-tabs-content').mCustomScrollbar();
                    // });
                });
            },
            mapInit(position){
                let _position = [position.split(',')[0], position.split(',')[1]];
                console.log(_position);
                this.xf_map = new AMap.Map("xf_map", {
                    resizeEnable: true,
                    center: _position,
                    zooms: [3, 17.5],
                    mapStyle: 'amap://styles/8015939191c19f9d3889fb6066703978',
                });
                let labelMarker = new AMap.LabelMarker({
                    position: position,
                    zIndex: 16,
                    // 将第一步创建的 icon 对象传给 icon 属性
                    icon: {
                        // 图标类型，现阶段只支持 image 类型
                        type: 'image',
                        // 图片 url
                        image: marker3Img,
                        // 图片尺寸
                        size: [20, 30],
                        // 图片相对 position 的锚点，默认为 bottom-center
                        anchor: 'center',
                    },
                });
                var labelsLayer = new AMap.LabelsLayer({
                    zooms: [3, 20],
                    zIndex: 1000,
                    // 该层内标注是否避让
                    collision: false,
                    // 设置 allowCollision：true，可以让标注避让用户的标注
                    allowCollision: false,
                });
                labelsLayer.add(labelMarker);
                this.xf_map.add(labelsLayer);
            },
            showImg(imgSrc) {
                if(!imgSrc){
                    return;
                }
                this.modalShow = true;
                this.modalImgSrc = imgSrc;
            },
            getDateFn(time){
                return getDate(time, 'year');
            },
            getDeviceDetail(){ //获取详情
                let _this = this;
                let url = contBlockUrl.deviceDetail;
                var data = {
                    type: 'get',
                    url: url + this.$store.state.showDetail.item.deviceId,
                    obj: {
                        orgId: this.$store.state.baseInfoLayer.baseInfoId,
                    }
                };
                _this.$Axios(data).then((res) => {
                    console.log(res.data.data);
                    if(res.data.success){
                        _this.deviceModel  = res.data.data;
                        if(_this.deviceModel.maintenanceTel == "~"){
                            _this.deviceModel.maintenanceTel = '';
                        }
                        if(_this.deviceModel.manufacturerTel == "~"){
                            _this.deviceModel.manufacturerTel = '';
                        }
                        _this.deviceModel.serviceTime = getDate(_this.deviceModel.serviceTime, 'year');
                        _this.deviceModel.serverStateChangeTime = getDate(_this.deviceModel.serverStateChangeTime, 'year');
                        _this.defaultList = [].concat([{
                            name:res.data.data.name,
                            url:res.data.data.planFile,
                        }])
                    }
                    this.$nextTick(()=>{
                        $JQ('.per-info-wrap:visible .modal-body').mCustomScrollbar();
                    });
                });
            },
            eventTabChange(name){
                this.currentPage = 1;
                this.tableTdArr = [];
                this.totalCount = 0;
                console.log(name);
                // $('.eventScroll').mCustomScrollbar('destroy');
                this.dataInit();
                this.getSelect();
                this.getEventsTable();
            },
            selectTime(value) {
                this.beginTime = value[0];
                this.endTime = value[1];
                this.currentPage = 1;
                this.tableTdArr = [];
                if(!!this.optionBtnIndex){ // 预案管理
                    this.getListData();
                }else{
                    this.getEventsTable(); //事件记录
                }

            },//日期选择
            statusSelectFn(){ //类型选择
                this.currentPage = 1;
                this.tableTdArr = [];
                this.totalCount = 0;
                if(this.selectGetStatus){
                    this.getEventsTable();
                }
            },
            handleSelectFn(){ //状态选择
                this.currentPage = 1;
                this.tableTdArr = [];
                this.totalCount = 0;
                if(this.handleGetStatus){
                    this.getEventsTable();
                }

            },
            getEventsTable(){
                this.tableInitStatus = false;
                // $('.eventScroll').mCustomScrollbar('destroy');
                this.selectGetStatus = false;
                this.handleGetStatus = false;
                this.loading_status = true;
                let _this = this;
                let url = '';
                var data = {
                    type: 'get',
                    url: url,
                    obj: {
                        user: this.loginData.loginName,
                        password: this.loginData.passWord
                    }
                };
                if(this.beginTime){
                this.beginTime=this.beginTime+' 00:00:00';
                this.endTime=this.endTime+' 23:59:59';
                }
                
                if(this.$store.state.eventStatis.type == 'xfz'){ //消防主机
                    if(this.eventTabIndex == '1'){ //故障
                        data.url = contBlockUrl.xfEventsTab2;
                        data.obj = {
                            currentPage: this.currentPage,
                            pageSize: 10,
                            orgId: this.$store.state.baseInfoLayer.baseInfoId,
                            sortFields:"ctime",
                            controlHostId: this.$store.state.eventStatis.id,
                            beginTime: new Date(this.beginTime).getTime() || null,
                            endTime: new Date(this.endTime).getTime() || null,
                            state: this.handleStatus || null,
                            type: this.selectVal || null,
                        }
                    }else { //火灾报警
                        data.url = contBlockUrl.xfEventsTab1;
                        data.obj = {
                            currentPage: this.currentPage,
                            pageSize: 10,
                            orgId: this.$store.state.baseInfoLayer.baseInfoId,
                            alarmType:0,
                            sortFields:"ctime",
                            controlHostId: this.$store.state.eventStatis.id,
                            beginTime: new Date(this.beginTime).getTime() || null,
                            endTime: new Date(this.endTime).getTime() || null,
                            state: this.handleStatus || null,
                            type: this.selectVal || null,
                        }
                    }
                }else if(
                    this.$store.state.eventStatis.type == 'xfz1' ||
                    this.$store.state.eventStatis.type == 'xfz2'
                ){
                    if(this.eventTabIndex == '1'){ //故障
                        data.url = contBlockUrl.xfEventsTab2;
                        data.obj = {
                            currentPage: this.currentPage,
                            pageSize: 10,
                            orgId: this.$store.state.baseInfoLayer.baseInfoId,
                            sortFields:"ctime",
                            tid: this.$store.state.eventStatis.id,
                            beginTime: new Date(this.beginTime).getTime() || null,
                            endTime: new Date(this.endTime).getTime() || null,
                            state: this.handleStatus || null,
                            type: this.selectVal || null,
                        }
                    }else { //火灾报警
                        data.url = contBlockUrl.xfEventsTab1;
                        data.obj = {
                            currentPage: this.currentPage,
                            pageSize: 10,
                            orgId: this.$store.state.baseInfoLayer.baseInfoId,
                            alarmType:0,
                            sortFields:"ctime",
                            tid: this.$store.state.eventStatis.id,
                            beginTime: new Date(this.beginTime).getTime() || null,
                            endTime: new Date(this.endTime).getTime() || null,
                            state: this.handleStatus || null,
                            type: this.selectVal || null,
                        }
                    }
                }else if(this.$store.state.eventStatis.type == 'dq'){
                    data.obj = {
                        currentPage: this.currentPage,
                        pageSize: 10,
                        orgId: this.$store.state.baseInfoLayer.baseInfoId,
                        beginTime: new Date(this.beginTime).getTime() || null,
                        endTime: new Date(this.endTime).getTime() || null,
                        state: this.handleStatus || null,
                        type: this.selectVal || null,
                        content: this.searchVal || null,
                        tid: this.$store.state.eventStatis.id,
                    };
                    if(this.eventTabIndex == '0'){ //报警
                        data.url = contBlockUrl.eventsList1;
                    }else if(this.eventTabIndex == '1'){ //预警
                        data.url = contBlockUrl.eventsList2;
                    }else if(this.eventTabIndex == '2'){ //隐患
                        data.url = contBlockUrl.eventsList3;
                        delete data.obj.tid;
                        data.obj['deviceId'] = this.$store.state.eventStatis.item.deviceId;
                    }else if(this.eventTabIndex == '3'){ //故障
                        data.url = contBlockUrl.eventsList4;
                    }
                }
                else if(this.$store.state.eventStatis.type == 'qt'||this.$store.state.eventStatis.type == 'qt1'||this.$store.state.eventStatis.type == 'qt2'){
                    data.obj = {
                        currentPage: this.currentPage,
                        pageSize: 10,
                        orgId: this.$store.state.baseInfoLayer.baseInfoId,
                        beginTime: new Date(this.beginTime).getTime() || null,
                        endTime: new Date(this.endTime).getTime() || null,
                        type: this.selectVal || null,
                        content: this.searchVal || null,
                        tid: this.$store.state.eventStatis.id,
                    };
                    if(this.eventTabIndex == '0'){ //报警
                        data.url = contBlockUrl.eventsList1;
                        data.obj['states']=this.handleStatus || null;
                    }else if(this.eventTabIndex == '1'){ //预警
                        data.url = contBlockUrl.eventsList2;
                        data.obj['state']=this.handleStatus || null;
                    }else if(this.eventTabIndex == '2'){ //隐患
                        data.url = contBlockUrl.eventsList3;
                        delete data.obj.tid;
                        data.obj['deviceId'] = this.$store.state.eventStatis.item.deviceId;
                        data.obj['state']=this.handleStatus || null;
                    }else if(this.eventTabIndex == '3'){ //故障
                        data.url = contBlockUrl.eventsList4;
                        data.obj['state']=this.handleStatus || null;
                    }
                }
                _this.$Axios(data).then((res) => {
                    console.log(res.data.data);
                    this.loading_status = false;
                    if (res && res.data.data.length > 0) {
                        _this.tableTdArr = [...this.tableTdArr, ...res.data.data];
                        _this.totalCount = res.data.totalCount
                    }
                    console.log(_this.tableTdArr)
                    if(!res.data.data.length){
                        this.hasData = false;
                        return;
                    }else {
                        this.hasData = true;
                    }
                    console.log(this.hasData);
                    
                    _this.tableInitStatus = true;
                    _this.$nextTick(()=>{
                        this.selectGetStatus = true;
                        this.handleGetStatus = true;
                        $JQ('.eventScroll:visible').mCustomScrollbar({
                            callbacks: {
                                onTotalScroll: function () {
                                    if ((_this.tableTdArr.length == res.data.totalCount) || (res.data.data.length == 0)) {
                                        console.log('没有更多数据');
                                        return;
                                    } else {
                                        console.log('加载更多');
                                        _this.currentPage += 1;
                                        _this.getEventsTable();
                                    }
                                }
                            }
                        });
                    });
                });
            },
            getSelect(){
                if(this.$store.state.eventStatis.type != 'xfz'){
                    if(this.eventTabIndex == '0'){ //报警
                        this.getSelectFn(contBlockUrl.typeList, '2');
                    }else if(this.eventTabIndex == '1'){ //预警
                        this.getSelectFn(contBlockUrl.typeList1, '1');
                    }else if(this.eventTabIndex == '3'){ //故障
                        this.getSelectFn(contBlockUrl.typeList1, '3');
                    }
                }else{ //消防主机 select类型
                    if(this.eventTabIndex == '1'){  //故障
                        this.getSelectFn(contBlockUrl.typeList1, '3');
                    }
                }
            },
            getSelectFn(url, type){ //获取类型下拉框
                let _this = this;
                var data = {
                    type: 'get',
                    url: url,
                    obj: {
                        orgId: this.$store.state.baseInfoLayer.baseInfoId,
                        exceptionType: type,
                        pageSize: 200,
                        currentPage: 1,
                    }
                };
                _this.$Axios(data).then((res)=>{
                    console.log(res);
                    console.log('类型下拉框');
                    if(res.data.success){
                        let mockData = [];
                        for(let i = 0; i<res.data.data.length; i++ ){
                            let obj ={};
                            obj.code = res.data.data[i].code;
                            obj.name = res.data.data[i].name;
                            mockData.push(obj);
                        }
                        this.selectArr = mockData;
                    }
                });

            },
            showImg(imgSrc) {
                if(!imgSrc){
                    return;
                }
                this.modalShow = true;
                this.modalImgSrc = imgSrc;
            },
            getYanLianData(){
                let id=this.taskId;
                var data = {
                    type: 'get',
                    url: 'mcbw/drill_tasks/' + id,
                    obj: {}
                };
                this.$Axios(data).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.yanlianList=res.data.data;
                        if (res.data.data.doneTaskVOS[0].filePaths){
                            let arr = [];
                            res.data.data.doneTaskVOS[0].filePaths.map((value) =>{
                                arr.push({
                                    url: value,
                                })
                            })
                            this.defaultList = [].concat(arr);
                        }else{
                            this.yanlianList.doneTaskVOS[0].filePaths = [];
                            this.yanlianList.doneTaskVOS[0].fileName = '';
                        }
                    }
                });
            },
            getPxData(){
                let id=this.taskId;
                var data = {
                    type: 'get',
                    url: 'mcbw/train_tasks/' + id,
                    obj: {}
                };
                this.$Axios(data).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.peixunList=res.data.data;
                        if (res.data.data.doneTaskVOS[0].filePaths) {
                            let arr = [];
                            res.data.data.doneTaskVOS[0].filePaths.map((value) => {
                                arr.push({
                                    url: value,
                                })
                            })
                            this.defaultList = [].concat(arr);
                        }else{
                            this.peixunList.doneTaskVOS[0].filePaths = [];
                            this.peixunList.doneTaskVOS[0].fileName = '';
                        }
                    }
                });
            },
            dataInit() {
                this.beginTime = undefined;
                this.endTime = undefined;
                this.selectArr = [{name: '',code: ''}];
                this.cardList = [];
                this.totalCount = '',
                this.cardTotalCount = 0;
                this.currentPage = 1;
                this.currentPage1 = 1;
                this.inpVal = '';
                this.tableTdArr = [];
                this.handleStatus = '';
                this.handleGetStatus = true;
                this.selectVal = '';
                this.selectGetStatus = true;
                this.selTime = null;
                this.tableInitStatus = false;
                this.loading_status = false;
                this.hasData = false;
            },
            showDetailFn(index,id) {
                console.log(index);
                this.formValidate = {};
                this.detailLayerIndex = index;
                this.$nextTick(() => {
                    $JQ('.per-info-wrap:visible .detail-info-layer .detail-body-wrap').mCustomScrollbar();
                });
                switch (index) {
                    case 0:
                        this.userDetail(id);
                        break;
                    case 1:
                        this.importantPartsDetail(id);
                        break;
                    case 2:
                        this.buildingsDetail(id);
                        break;
                }
            },
            open(val){
                window.open(val)
            },
            hideDetail() {
                this.detailLayerIndex = '';
            },
            closeModal() {
                this.eventTabIndex = '0';
                this.deviceModel = {};
                this.tableTdArr = [];
                this.tableInitStatus = false;
                // $('.mCustomScrollbar1').mCustomScrollbar('destroy');
                // $('.eventScroll').mCustomScrollbar('destroy');
                this.$emit('modalClose', new Date());
            },
            tabChange(name) {
              this.surroundingResources=name+''
              this.dataInit();
              this.getListData();
            },
            sourceTab(type, index, val) { //周边资源 切换类型
                this.resourceType = val;
                switch (type) {
                    case 0:
                        this.resources1Index = index;
                        break;
                    case 1:
                        this.resources2Index = index;
                        break;
                    case 2:
                        this.resources3Index = index;
                        break;
                }
                // this.tableTdArr = [];
                this.dataInit();
                this.getListData();
            },
            inputSearch() { //input框搜索
                console.log(this.inputVal);
                this.tableTdArr = [];
                this.totalCount = 0;
                this.currentPage = 1;
                this.getListData();
            },
            btnSearch(){
                this.tableTdArr = [];
                this.totalCount = 0;
                this.currentPage = 1;
                this.getEventsTable();
            },
            getListData() {
                this.tableInitStatus = false;
                this.loading_status = true;
                $JQ('.mCustomScrollbar1:visible').mCustomScrollbar('update');
                let _this = this;
                let url = '';
                let params = {};
                let data = {
                    type: 'get',
                    url: url,
                    obj: {}
                }
                console.log(this.optionBtnIndex);

                switch (this.optionBtnIndex) {
                    case 0: //人员信息
                        data.url = userList;
                        params = {
                            currentPage: this.currentPage,
                            // pageSize: this.pageSize,
                            pageSize:500,
                            orgId: this.$store.state.baseInfoLayer.baseInfoId,
                            name: this.inpVal,
                            userType: 1,
                        }
                        break;
                    case 1: //相关图档
                        data.url = buildingDocuments;
                        params = {
                            currentPage: this.currentPage,
                            pageSize: 500,
                            orgId: this.$store.state.baseInfoLayer.baseInfoId,
                            description: this.inpVal,
                        }
                        break;
                    case 2: //重点部位
                        data.url = importantParts;
                        params = {
                            currentPage: this.currentPage,
                            pageSize: 500,
                            orgId: this.$store.state.baseInfoLayer.baseInfoId,
                            name: this.inpVal,
                            buildingId: this.inpBuildingId,
                            importantPartType: this.inpImportantPartType,
                        }
                        break;
                    case 3: //周边资源
                    if(this.surroundingResources=='1') data.url = surroundInfo1;
                    if(this.surroundingResources=='2') data.url = surroundInfo2;
                    if(this.surroundingResources=='3') data.url = surroundInfo3;
                    if(this.surroundingResources=='4') data.url = surroundInfo4;
                    if(this.surroundingResources=='5') data.url = surroundInfo5;
                    if(this.surroundingResources=='6') data.url = surroundInfo6;
                    if(this.surroundingResources=='7') data.url = surroundInfo7;
                        params = {
                            currentPage: this.currentPage,
                            pageSize: 500,
                            orgId: this.$store.state.baseInfoLayer.baseInfoId,
                            name: this.inpVal,
                        }
                        break;
                    case 4: //建筑构物
                        data.url = buildings;
                        params = {
                            currentPage: this.currentPage,
                            pageSize: 500,
                            orgId: this.$store.state.baseInfoLayer.baseInfoId,
                            name: this.inpVal,
                        }
                        break;
                    case 5: //预案管理
                        data.url = reservePlan;
                        params = {
                            currentPage: this.currentPage,
                            pageSize: 500,
                            orgId: this.$store.state.baseInfoLayer.baseInfoId,
                            name: this.inpVal,
                            beginTime: this.beginTime,
                            endTime: this.endTime,
                        }
                        break;
                }
                data.obj = params;
                this.$Axios(data).then((res) => {
                    this.loading_status = false;
                    if (res.data.success) {
                        if(res.data.data.length == 0){
                            this.hasData = false;
                            return;
                        }else{
                            this.totalCount = res.data.totalCount;
                            this.tableTdArr = [...this.tableTdArr, ...res.data.data];
                            this.hasData = true;
                            this.tableInitStatus = true;
                            // var _this=this
                            // _this.$nextTick(() => {
                            //     $JQ('.mCustomScrollbar1:visible').mCustomScrollbar({
                            //         callbacks: {
                            //             onTotalScroll: function () {
                            //                 if (res.data.data==0) {
                            //                     console.log('没有更多数据');
                            //                     return;
                            //                 } else {
                            //                     console.log('加载更多');
                            //                     _this.currentPage += 1;
                            //                     _this.getListData();
                            //                 }
                            //             }
                            //         }
                            //     });
                            // });
                        }
                    }
                });
            },
            getOwnerBuild() {   //获取建筑类别
                var data = {
                    type: 'get',
                    url: buildings,
                    obj: {
                        pageSize: 1000,
                        currentPage: 1,
                        orgId: this.$store.state.baseInfoLayer.baseInfoId,
                    }
                };
                this.$Axios(data).then((res) => {
                    this.ownerBuildList = res.data.data;

                });
            },
            getImportType() {   //获取重点类型
                var data = {
                    type: 'get',
                    url: importantPartType,
                    obj: {
                        pageSize: 1000,
                        currentPage: 1,
                        buildingId: '',
                        importantPartType: 1
                    }
                };
                this.$Axios(data).then((res) => {
                    this.importTypeList = res.data.data;

                });
            },
            userDetail(id) {   //获取人员详情
                let _this = this;
                const eduInfoFn = function () {
                    return new Promise((resolve, reject)=>{
                        var data = {
                            type: 'get',
                            url: eduInfo,
                            obj: {
                                pageSize: 1000,
                                currentPage: 1,
                            }
                        };
                        _this.$Axios(data).then((res) => {
                            // console.log(res.data.data);
                            // console.log('文化程度字典项');
                            _this.eduInfoArr = res.data.data;
                            resolve();
                        });  
                    });
                }
                
                const userFn = function () {
                    return new Promise((resolve, reject)=>{
                        var data = {
                            type: 'get',
                            url: userList + '/' + id,
                            obj: {}
                        };
                        _this.$Axios(data).then((res) => {
                            console.log(res.data.data);
                            _this.formValidate = res.data.data;
                            _this.formValidate.trainingTime = getDate(res.data.data.trainingTime, 'year');
                            _this.formValidate.issueDate = getDate(res.data.data.issueDate, 'year');
                            for(let i = 0; i < _this.eduInfoArr.length; i++){
                                if(_this.eduInfoArr[i].value == res.data.data.educationDegree){
                                     _this.formValidate['eduInfo'] = _this.eduInfoArr[i].name;
                                }
                            }
                            resolve();
                        }); 
                    }); 
                }
                async function userData(params) {
                    await eduInfoFn();
                    await userFn();
                }
                userData();
            },
            buildingsDetail(id) {   //获取建筑构物详情
                var data = {
                    type: 'get',
                    url: buildings + '/' + id,
                    obj: {}
                };
                this.$Axios(data).then((res) => {
                    console.log(res.data.data);
                    this.formValidate = res.data.data;
                    console.log(this.formValidate.buildingStructureTypeCode);
                    this.formValidate.buildTime = getDate(res.data.data.buildTime, 'year');

                });
            },
            importantPartsDetail(id) {   //获取重点部位详情
                var data = {
                    type: 'get',
                    url: importantParts + '/' + id,
                    obj: {}
                };
                this.$Axios(data).then((res) => {
                    console.log(res.data.data);
                    this.formValidate = res.data.data;
                    this.formValidate.dutyName = (res.data.data.dutyCode == 1 ? '本单位管理' : '本单位使用');

                });
            },
            getCamerasMonitor() {   //获取摄像头列表
                let _this = this;
                var data = {
                    type: 'get',
                    url: camerasMonitor,
                    obj: {
                        currentPage: this.currentPage1,
                        pageSize: this.pageSize1,
                        orgId: this.$store.state.baseInfoLayer.baseInfoId,
                    }
                };
                this.$Axios(data).then((res) => {
                    console.log(res.data.data);
                    if (res && res.data.data.length > 0) {
                        this.cardList = [...this.cardList, ...res.data.data];
                        this.cardTotalCount = res.data.totalCount;
                        // $('.video-list-wrap').mCustomScrollbar('destroy');
                        if(res.data.totalCount == 1){
                            this.targetCamera(res.data.data[0]);
                        }
                    }

                    this.$nextTick(()=>{
                        $JQ('.per-info-wrap:visible .video-scroll').mCustomScrollbar({
                            callbacks: {
                                onTotalScroll: function () {
                                    if ((_this.cardList.length == res.data.totalCount) || (res.data.data.length == 0)) {
                                        console.log('没有更多数据');
                                        return;
                                    } else {
                                        console.log('加载更多');
                                        _this.currentPage1 += 1;
                                        _this.getCamerasMonitor();
                                    }
                                }
                            }
                        });
                    });

                });
            },
            getToken(){
                var data = {
                    type: 'get',
                    url: `/mcbw/cameras/token`,
                    obj: {}
                };
                this.$Axios(data).then((res) => {
                    if (res.data.success) {
                        this.accessToken = res.data.data
                    }
                
                })
            },
            mouseenterVideo(id,url){
                this.currentVideoId = id
                this.$nextTick(()=>{
                    if(url && url.includes('rtsp://')){
                        this.videoType = "5";
                    } else if(url && url.includes('ezopen')){
                        this.videoType = "1"
                        this.player =  new EZUIKit.EZUIKitPlayer({
                        autoplay: true,
                        id: "video-container",
                        accessToken: this.accessToken,
                        url,
                        template: "simple", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
                        // 视频上方头部控件
                        //header: ["capturePicture", "save", "zoom"], // 如果templete参数不为simple,该字段将被覆盖
                        //plugin: ['talk'],                       // 加载插件，talk-对讲
                        // 视频下方底部控件
                        // footer: ["talk", "broadcast", "hd", "fullScreen"], // 如果template参数不为simple,该字段将被覆盖
                        // audio: 1, // 是否默认开启声音 0 - 关闭 1 - 开启
                        // openSoundCallBack: data => console.log("开启声音回调", data),
                        // closeSoundCallBack: data => console.log("关闭声音回调", data),
                        // startSaveCallBack: data => console.log("开始录像回调", data),
                        // stopSaveCallBack: data => console.log("录像回调", data),
                        // capturePictureCallBack: data => console.log("截图成功回调", data),
                        // fullScreenCallBack: data => console.log("全屏回调", data),
                        // getOSDTimeCallBack: data => console.log("获取OSDTime回调", data),
                            width:387,
                            height: 232
                        });
                    }else if(url && url.includes('rtsp://')){
                        this.videoType = "2";
                    } else  if(url.includes('ws://') || url.includes('wss://')){
                        this.videoType = "4";
                    } else if(url && url.includes('http')){
                        this.videoType = "3";
                        this.$nextTick(() => {
                            let parentNode = document.getElementById(id).parentNode;
                            let width = parentNode.offsetWidth;
                            let height = parentNode.offsetHeight;
                            if(!this.videoPlayerList.hasOwnProperty(id)){
                                this.videoPlayerList[id] = videojs(id, {
                                    src: url,
                                    muted: true,
                                    autoplay: true,
                                    controls: false,
                                    height: height,
                                    width: width,
                                },function(){
                                    videojs.log('播放器已经准备好了!');
                                });
                            } else {
                                this.videoPlayerList[id].play()
                            }
                        })
                    }
                })
                
                
            },
            mouseleaveVideo(id){
                if(this.videoPlayerList.hasOwnProperty(id)){
                    this.videoPlayerList[id].dispose()  //销毁
                    delete this.videoPlayerList[id]
                }
                this.currentVideoId = ''
            },
            targetCamera(list) {
                console.log(list)
                this.camera = true;
                this.cameraModel = list;
                this.videoSrc = list.hlsAddr;
                this.videoDeviceId = list.id;
                this.channelNum = list.channelNum;
                this.videoSid = list.num;
                this.cameraModel._name = list.name;
                this.mouseleaveVideo(list.id);
                // $('.video-scroll').mCustomScrollbar('destroy');
                // this.videoArr.push(1);
                // this.$nextTick(() => {
                //     this.initVideo(list.hlsAddr);
                // })
            },
            initVideo(url) {
                let parentNode = document.getElementById('myPlayer').parentNode;
                let width = parentNode.offsetWidth;
                let height = parentNode.offsetHeight;
                if(this.player){
                    this.player.src(url);
                    this.player.play();
                    return;
                }
                this.player = videojs('myPlayer', {
                    src: url,
                    autoplay: true,
                    height: height,
                    width: width,
                },function(){
                    videojs.log('111播放器已经准备好了!');
                    this.play();
                });
            },
            cancel() {
                this.camera = !this.camera;
                this.videoSrc = ''
                // this.videoArr.pop();
                // this.$nextTick(()=>{
                //     this.player.dispose();  //销毁
                //     this.player = null;
                //     let _this = this;
                //     $('.video-scroll').mCustomScrollbar({
                //         callbacks: {
                //             onTotalScroll: function () {
                //                 if ((_this.cardList.length == _this.cardTotalCount) || (_this.cardTotalCount == 0)) {
                //                     console.log('没有更多数据');
                //                     return;
                //                 } else {
                //                     console.log('加载更多');
                //                     _this.currentPage1 += 1;
                //                     _this.getCamerasMonitor();
                //                 }
                //             }
                //         }
                //     });
                // });
            },
            timestampToTime(timestamp) {
                if (timestamp == undefined) {
                    return '';
                } else {
                    var date = new Date(timestamp);//时间戳 -- 如果date为13位不需要乘1000  3-11修改
                    var Y = date.getFullYear() + '-';
                    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                    var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
                    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                    var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
                    return Y + M + D + h + m + s;
                }
            },

            getMeasuringPoint(id){
                this.list={
                    kg:[],
                    mnl:[],
                    gz:{},
                    zs:{}
                }
                var data = {
                    type: 'get',
                    url: `/mcbw/network_monitor/grep/pointNowValue/${id}`,
                    obj: {}
                };
                this.$Axios(data).then((result) => {
                    if (result.data.success) {
                        this.list.zs=result.data.data.zs;
                        this.list.gz=result.data.data.gz;
                        let arr=[];
                        let ayy=[];
                        if(result.data.data.mnl.length > 0){
                            result.data.data.mnl.map((value,index) => {
                                for(var y=0;y<value.length;y++){
                                    let unit=value[y].unit || '~';
                                    arr.push({
                                        pointValue: value[y].pointValue,
                                        id: value[y].id,
                                        name: value[y].name+"  ("+unit+")  "
                                    })
                                }
                                this.list.mnl=arr;
                            })
                        }
                        if(result.data.data.kg.length > 0){
                            result.data.data.kg.map((value,index) => {
                                for(var z=0;z<value.length;z++){
                                    ayy.push({
                                        pointValue: value[z].pointValue,
                                        name: value[z].name,
                                        pointTypeCode:value[z].pointTypeCode
                                    })
                                }
                                this.list.kg=ayy;
                            })
                        }
                    }
                })
            },
            curveEvent(itemId,id,name){
                this.modal1=true;
                this.pointName=name;
                this.deveceid=itemId;
                this.pointId=id;
                this.pointTime = getDate(new Date().getTime(), 'day');
                this.setChart();
            },
            setChart(){
                var data = {
                    type: 'get',
                    url: `/mcbw/network_monitor/graph/${this.deveceid}`,
                    obj: {
                        type:"mnl",
                        date:this.pointTime,
                        id:this.pointId
                    }
                };
                this.$Axios(data).then((res) => {
                    if (res.data.success) {
                        for (let value in res.data.data) {
                            this.chartList = res.data.data[value];
                        }
                        this.getChart();
                    }
                })
            },
            getChart(){
                this.curvnState="";
                let _this=this;
                let xAxisData=[];
                let yAxisData=[];
                var option={
                    grid:{},
                    legend: {},
                    xAxis: {},
                    yAxis: {},
                    label: {},
                    tooltip: {},
                    series: []
                }
                if(this.chart && this.chart.dispose){
                    this.chart.clear();
                    this.chart.dispose();
                }
                for(let i = 0; i < _this.chartList.length; i++){
                    xAxisData.push(_this.chartList[i].time.slice(11,16));
                    yAxisData.push(_this.chartList[i].value);
                }
                    option.grid={
                    top: 30,
                    bottom: 20,
                    left: 20,
                    right: 20,
                    containLabel: true
                },
                    option.xAxis={
                        type: 'category',   // 还有其他的type，可以去官网喵两眼哦
                        data: xAxisData,   // x轴数据
                        name: '',   // x轴名称
                        // x轴名称样式
                        nameTextStyle: {
                            fontSize:12,
                            fontWeight:400,
                            textAlign:'left',
                            color:'#909399',
                            lineHeight:17
                        }
                    },
                    option.yAxis={
                        type: 'value',
                        name: '',   // y轴名称
                        // y轴名称样式
                        nameTextStyle: {
                            fontSize:13,
                            fontWeight:600,
                            textAlign:'left',
                            color:'#2e2e2e',
                            lineHeight:18
                        },
                        style:{
                            marginBottom:20
                        }
                    },
                    option.tooltip={
                        trigger: 'axis'   // axis   item   none三个值
                    },
                    option.series=[
                        {
                            symbol: 'circle',     //折点设定为实心点
                            data:yAxisData,
                            type: 'line',
                            itemStyle:{
                                normal:{
                                    color:'#2E90E9', //折点颜色
                                    lineStyle:{
                                        color:'#4A90E2' //折线颜色
                                    }
                                }
                            }
                        }
                    ]
                this.chart = _this.$echarts.init(document.getElementById('mainline'));
                if(yAxisData && yAxisData.length>0){
                    this.chart.setOption(option);
                }else{
                    this.curvnState='未查询到历史数据';
                }
                window.addEventListener('resize', function(){
                    _this.chart.resize();
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    /deep/ .ivu-tabs-nav .ivu-tabs-tab{
        color: rgba(116, 217, 255,.5);
    }
    /deep/ .ivu-tabs-nav .ivu-tabs-tab-active{
        color: rgba(116, 217, 255,1);
    }
    /deep/ .ivu-tabs-ink-bar{
        background-color: #74D9FF;
    }
    /deep/ .ivu-tabs-bar{
        border: none;
    }
    .modal-layer-wrap {
        /deep/ .ivu-tabs{
            padding-left: 5px;
            height: 100%;
            display: flex;
            flex-direction: column;
            .ivu-tabs-content{
                flex: 1;
                flex-shrink: 0;
                overflow: hidden;
                .ivu-tabs-tabpane{
                    height: 100%;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                }
            }
        }
        .modal-list {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 60vh;
            //background: #001A29;
            //border-radius: 20px 20px 0 0;
            background: rgba(6,18,44,1) url('../assets/img/maskBg.png') center center/101% 102% no-repeat;
            // overflow: hidden;
            // transition: all .3s;
            // transform: translateY(60vh);
            z-index: 200;
            display: flex;
            flex-direction: column;
            // &.active {
            //     transform: translateY(0);
            // }
            .modal-head {
                margin: 8px 10px;
                height: 30px;
                padding-right: 15px;
                color: #a2d8ff;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                -webkit-box-pack: justify;
                -ms-flex-pack: justify;
                justify-content: space-between;
                background: -webkit-gradient(linear,left top,right top,from(#60aed4),color-stop(20%,#041936));
                background: linear-gradient(90deg,#60aed4 0,#041936 20%);
                text-indent: 8px;
                span {
                    color: #a2d8ff;
                    font-size: 20px;
                    position: absolute;
                    float: left;
                    margin-left: 25px
                }
                img {
                    cursor: pointer;
                }
            }
            .page-content{
                flex: 1;
                flex-shrink: 0;
                // overflow: hidden;
            }
            .modal-body {
                height: calc(60vh - 50px);
                overflow: hidden;
                display: flex;
                flex-direction: column;
                padding: 30px 20px;
                #xf_map{
                    height: 100%;
                }
                .option-wrap {
                    display: flex;
                    justify-content: space-between;
                }
                div{
                    .noData{
                        height: 100%;
                        line-height: 150px;
                        text-align: center;
                        font-size: 18px;
                        color: #5d6469
                    }
                }
                .tab-head{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    color: #08F4F7;
                    .contact{
                        display: flex;
                        .field-span{
                            max-width: 120px;
                            margin-left: 50px;
                            &:first-child{
                                margin-left: 0;
                            }
                        }
                    }
                }
                .tab-option{
                    margin-top: 20px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .btn-wrap{
                        display: flex;
                        align-items: center;
                        .i-wrap{
                            display: flex;
                            align-items: center;
                            i.iconfont{
                                color: #ed4014;
                                font-size: 20px;
                            }
                        }

                        button{
                            margin-left: 10px;
                        }
                        .default-btn{
                            border-color: rgba(8,244,247,.3);
                            background-color: hsla(0,0%,100%,.1);
                            color: #08f4f7;
                        }
                    }
                }
            }
            .detail-info-layer {
                background: rgba(6,18,44,1) url('../assets/img/maskBg.png') center center/101% 102% no-repeat;
                overflow: hidden;
                position: absolute;
                width: 100%;
                height: calc(60vh - 50px);
                top: 50px;
                padding: 30px 20px;
                transition: all .3s;
                transform: translateY(60vh);
                display: flex;
                flex-direction: column;
                &.active {
                    transform: translateY(0);
                }
                .detail-head-wrap {
                    display: flex;
                    align-items: center;
                    span {
                        color: #A2D8FF;
                        font-size: 14px;
                        margin-right: 20px;
                        background: linear-gradient(90deg,#60aed4 0,#041936 80%);
                    }
                }
                .sub-tit {
                    font-size: 14px;
                    color: #64BDE0;
                    margin-top: 30px;
                }
                .detail-body-wrap {
                    flex: 1;
                    flex-shrink: 0;
                    overflow: hidden;
                }
                .form-wrap {
                    padding: 30px 100px 0;
                }
            }
            &.device-modal{
                /deep/ .update_wrap{
                    align-items: center;
                    span,
                    img{
                        margin-right: 10px;
                    }
                    span{
                        color: #70d3f8;
                    }
                    img{
                        padding: 10px;
                        cursor: pointer;
                    }
                }
                /deep/ .textRight{
                    overflow: hidden;
                }
                .modal-body-box{
                    flex: 1;
                    flex-shrink: 0;
                    overflow: hidden;
                }
                /deep/ .update_wrap{
                    display: flex;
                    justify-content: flex-end;
                    .update_info{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        span{
                            color: #70d3f8;
                        }
                        .ivu-btn-ghost.ivu-btn-error,
                        .ivu-btn-error{
                            color: #00FFFF;
                            background-color: #17314C;
                            border-color: #00FFFF;
                            span{
                                color: #00FFFF;
                            }
                        }
                        button{
                            margin-left: 10px;
                        }
                    }
                }
                /deep/ .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab{
                    color: #74d8ff;
                    background: none;
                    //border-color: none;
                    border: none;
                }
                /deep/ .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active{
                    color: #74d8ff;
                    //background-color: #0D8D8C;
                    border-bottom: 1px solid #a3e5ff !important;
                }
                /deep/ .ivu-tabs-bar{
                    border-bottom: none;
                }
                /deep/ table th{
                    background: #0c2745;
                    color: #7db3da;
                }
                /deep/ .ivu-table-border:after,
                /deep/ .ivu-table:before{
                    background: none!important;
                }
                /deep/ .ivu-table,
                /deep/ table{
                    background: none;
                    border-collapse: separate;
                    border-spacing: 0px 5px;
                }
                /deep/ .ivu-table td,
                /deep/ .ivu-table th{
                    border-bottom: none;
                }
                /deep/ table td{
                    background: #041936!important;
                    color: #afb9c4;
                }
                /deep/ div.m-t-10 span,
                /deep/ div.m-t-20 span{
                    color: #99d1f5;
                }
                /deep/ .textRight:not(.m-t-10){
                    span{
                        color: #0E8B8A;
                    }
                    .ivu-btn-ghost.ivu-btn-error,
                    .ivu-btn-error,
                    .ivu-btn-primary{
                        color: #a1d7fe;
                        background-color: #162f4d;
                        border-color: #234769;
                        span{
                            color: #a1d7fe;
                        }
                    }
                    button{
                        margin-left: 10px;
                    }
                }
                /deep/ .ivu-radio-group-button .ivu-radio-wrapper{
                    color: #74D9FF;
                    background: none;
                    border-color: #74D9FF;
                }
                /deep/ .ivu-radio-group-button .ivu-radio-wrapper-checked{
                    color: #74D9FF;
                    background: #1c92c8;
                    border-color: #74D9FF;
                    box-shadow: none;
                }
            }
        }
    }
    .detailTile{
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 16px;
    color: #515a6e;
    line-height: 1;
    padding: 10px 12px 10px 0;
    box-sizing: border-box;
    color: #A2D8FF;

}
    .detailModal{
    margin-bottom: 34px;
}
    .detailTextArea{
    border-color: rgba(8,244,247,.3);
    background-color: hsla(0,0%,100%,.1);
    color: #08f4f7;
    width: 100%;
    padding: 4px 7px;
}
    .pxylimgs{
    display: inline-block;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    -webkit-box-shadow: 0 1px 1px rgba(0,0,0,.2);
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 10px;
}
    .modalImg {
        width: 500px;
        margin: 0 auto;
    }
    .video-card-list{
        .video-list {
            display: flex;
            flex-wrap: wrap;
            list-style: none;
            .list-item-wrap {
                width: 25%;
                padding: 15px 10px 10px;
                display: inline-block;
                .list-item {
                    border-radius: 10px;
                    overflow: hidden;
                    transition: all .2s ease-in-out;
                    box-shadow: 0 0 2px rgba(0,0,0,.2);
                    &:hover{
                        transform: scale(1.1);
                    }
                    .video-box{
                        position: relative;
                        
                        padding-top: 60%;
                        overflow: hidden;
                        background: #f9f9f9;
                        .cover {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            overflow: hidden;
                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        video {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            object-fit: fill;
                            background: #333;
                        }
                        .item-video{
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .item-title-box{
                        padding: 5px 0;
                        background: rgba(43,63,73,1);
                        .item-title{
                            display: flex;
                            justify-content: space-between;
                            padding: 0 10px;
                            p{
                                max-width: 50%;
                                height: 24px;
                                line-height: 24px;
                                font-size: 12px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                transform: translate3d(0,0,0);
                            }
                        }
                    }
                }
            }
        }
    }
    i.imgView {
        color: rgba(8, 244, 247, .7);
        cursor: pointer;
        &.active {
            color: rgba(8, 244, 247, .3);
            cursor: default;
        }
    }
    .ys_wrap{
        background: none;
        display: flex;
        .water_level,
        .water_pressure,
        .water_pump{
            width: 70%;
            overflow: hidden;
            margin: 0 auto;
            height: 330px;
            .bold{
                a{
                    img{
                        display: inline-block;
                    }
                }
            }
            .ys_block_tit,.ys_block_sub_tit{
                color: #74D9FF;
            }
        }
        .water_pump{
            width: 100%;
            overflow: initial;
            padding: 10px;
        }
    }
    .tc_wrap{

    }
/deep/ .mCSB_inside>.mCSB_container{
    margin-right: 10px!important;
}
/deep/ .mCSB_scrollTools{
    right: 0!important;
    .mCSB_dragger{
        background: rgba(255,255,255,.3);
        border-radius: 8px;
        .mCSB_dragger_bar{
            width: 8px;
        }
    }
    .mCSB_draggerRail{
        background-color: transparent;
    }
} 
    .loading{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%; 
    height: 100%;
    padding-top: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,.3);
    img{
        width: 200px;
    }
}
    .bottomCard{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-top: 1px solid #2b3c55;
        padding: 30px 0 20px;
        div{
            display: flex;
            align-items: center;
            position: relative;
            img{
                margin-right: 5px;
            }

        }
    }
    .modal-body-text span{
        color: #08f4f7;
    }
    .fire_pump{
        width: 500px;
        height: 540px;
        background-color: #012f3d;
        opacity: 0.9;
        border-radius: 19px;
        margin: auto;
        .fire_tit{
            padding: 10px;
        }
        .fire_tit img{
            display: inline-block;
            margin-left: 5px;
            vertical-align: text-bottom;
        }
        .fire_pump_two{
            display: flex;
            margin-bottom: 10px;
            flex-wrap: wrap;
            justify-content: center;
            height: 26%;
            align-items: center;
        }
        .fire_pump_two_atem{
            width: 25%;
            display: flex;
            align-items: center;
            flex-direction: column;
            margin-bottom: 12px;
        }
        .fire_pump_one{
            display: flex;
            flex-wrap:wrap;
            margin-bottom: 10px;
            height: 26%;
            justify-content: center;
            align-items: center;
        }
        .fire_pump_one_atem{
            width: 25%;
            display: flex;
            align-items: center;
            flex-direction: column;
            margin-bottom: 10px;
        }
        .fire_pump_one_atem_span{
            display: inline-block;
            margin-bottom: 3px;
        }
        .fire_pump_two_atem_img{
            display: inline;
        }
        .fire_pump_two_atem_p{
            margin-bottom: 6px;
        }
        .fire_pump_three{
            display: flex;
            justify-content:flex-end;
            padding-right: 30px;
        }
        .fire_pump_three_span{
            font-size: 16px;
            line-height: 34px;
            margin-right: 6px;
        }
        .fire_pump_three_img{
            vertical-align: middle;
        }
        .fire_pump_four{
            height: 30%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .fire_pump_four_img{
            height: 100%;
            display: inline-block;
        }
        .fire_pump_four_span{
            color: red;
            font-size: 25px;
            font-weight:600;
        }
    }
    .select-label{
        width: 70px;
        color: #08f4f7;
    }
    .curve {
        /deep/ .ivu-modal-header-inner {
            color: #08f4f7;
        }
        /deep/ .ivu-modal {
            top: 475px !important;
            left: 13%;
        }
        /deep/ .ivu-modal-content {
            background-color: #001a29;
        }
        /deep/ .ivu-modal-header {
            border-bottom: 1px solid #21333c;
        }
        /deep/ .ivu-icon-ios-close {
            color: #ffffff;
        }
        /deep/ .ivu-input {
            background-color: #212b31;
            border: 1px solid #323b3f;
        }
    }
    .tcqpartsty{
        overflow-y: auto !important;
    }
    #mainline{
        height: 300px;
    }
    .midTip{
        position: absolute;
        top: 50%;
        left: 44%;
    }
</style>


// WEBPACK FOOTER //
// src/components/base-layer-modal.vue